
const lessons = [
  {
  id: 1,
  title: "Loài người tìm kiếm Thiên Chúa",
  tag: "CHƯƠNG I",
  desc: "Khát vọng tìm gặp Thiên Chúa và cách con người nhận biết Ngài.",
  content: `
# I. LỜI CHÚA

“Từ một người, Thiên Chúa đã tạo thành toàn thể nhân loại, để họ ở trên khắp mặt đất; Người đã vạch ra những thời kỳ nhất định và những ranh giới cho nơi ở của họ. Như vậy là để họ tìm kiếm Thiên Chúa; may ra họ dò dẫm mà tìm thấy Người, tuy rằng thực sự Người không ở xa mỗi người chúng ta.”(Cv 17,26-28)

---

# II. TRÌNH BÀY

Trong cuốn sách tựa đề là “Tự thú”, Thánh Augustino viết: “Lạy Chúa, Chúa đã dựng nên con và lòng con luôn khắc khoải cho tới khi tâm hồn con được an nghỉ trong Chúa”. Thánh nhân đã bộc lộ tâm tư khắc khoải của mình là mong mỏi gặp Chúa để được an thỏa. Hẳn đây cũng là tâm trạng của nhiều người chúng ta: KHAO KHÁT TÌM GẶP CHÚA.

## 1. Loài người dựa vào đâu để tìm biết Thiên Chúa?

### a. Dựa vào thiên nhiên

Nhìn trời đất với trật tự lạ lùng của tinh tú, với muôn vàn kỳ diệu của trời đất, tháng năm, người ta nhận ra phải có Đấng Sáng Tạo và điều khiển vũ trụ. Ta gọi cách nhận biết này là cách nhận biết theo luật NHÂN QUẢ: nhìn hậu quả biết nguyên nhân.

### b. Dựa vào những khát vọng chính đáng trong lòng người.

Những khát vọng chính đáng trong lòng cũng giúp loài người nhận biết có Thiên Chúa.

Tự đáy lòng, người ta cảm thấy mình luôn khao khát điều chân thật, điều tốt, điều đẹp (gọi là Chân – Thiện – Mỹ). Những khát vọng ấy khiến người ta suy nghĩ rằng: phải có Đấng là cội nguồn sự thật, là căn nguyên sự tốt lành và là khuôn mẫu vẻ đẹp; vì có như thế, mới giải thích được tại sao loài người có những khát vọng đó, mới lấp đầy những ước vọng tự nhiên và rất chính đáng của loài người.

### c. Có cách nào khác giúp ta tìm kiếm Thiên Chúa không? (ngoài 2 khởi điểm vừa nêu trên, xuất phát từ cá nhân mỗi người).

Thưa có, đó là TÔN GIÁO. Nói chung, các tôn giáo đều giúp loài người nhận ra rằng: ngoài thế giới trần tục, còn có thế giới thần linh; ngoài thế giới hữu hình, còn có thế giới vô hình … Một số tôn giáo còn có những đóng góp tích cực hơn, giới thiệu chính Thiên Chúa cho loài người.

Riêng đạo CÔNG GIÁO giúp loài người tìm kiếm Thiên Chúa mà mình cho là bằng con đường chắn chắn và hiệu quả:

– Chắc chắn: vì đạo Công giáo do chính Thiên Chúa thiết lập. Chính Thiên Chúa sai Đức Kitô, Con của Ngài xuống trần, tỏ cho loài người con đường phải đi để gặp được Người (gọi là đạo MẠC KHẢI).

– Hiệu quả: vì cùng với việc vạch đường chỉ lối, Thiên Chúa còn cho loài người nhiều trợ lực, giúp trí khôn nhận định sáng suốt, ý chí kiên trì và tâm hồn phấn khởi trên đường tìm gặp Chúa.

## 2. Thiên Chúa là Đấng nào?

Thiên Chúa là Đấng dựng nên trời đất muôn vật.

Người ta còn dùng nhiều danh xưng khác để chỉ Thiên Chúa như: Đức Chúa Trời (Chúa của trời đất), Thượng Đế (Vua trên cao), Tạo Hóa, Hóa Công (Đấng sáng tạo vạn vật), Đấng Tối cao (vị cao hơn hết) … Những danh xưng như thế đều chỉ Đấng dựng nên mọi sự, Đấng làm chủ muôn loài.

---

# III. BÀI HỌC

01. H. Thiên Chúa là Đấng nào?

T. Thiên Chúa là Đấng dựng nên trời đất muôn vật, là Đấng ban hạnh phúc chân thật cho loài người.

02. H. Loài người dựa vào đâu để tìm biết Thiên Chúa?

T. Loài người dựa vào trật tự trong vũ trụ, vào những khát vọng chân chính, vào tôn giáo, cách riêng đạo CÔNG GIÁO, mà nhận biết Thiên Chúa.

---

# IV. THÁI ĐỘ SỐNG

Biết rằng chỉ có Thiên Chúa là Đấng dựng nên trời đất muôn vật, nên tôi quyết chí chuyên chăm học giáo lý để tìm gặp Người.

---

# V. CẦU NGUYỆN

Lạy Chúa, “con là người ngoại đạo, nhưng vẫn tin có Chúa ngự trên cao”[1]. Chính niềm tin đơn sơ ấy thúc giục con đi tìm Chúa.

Hôm nay, con thấy rõ hơn điều con cảm nghiệm trước kia, là khi nhìn ngắm trời đất, khi nhớ lại con có nhiều khát vọng mà lúc đạt được chẳng thấy thỏa mãn bao nhiêu, con mới xác tín rằng: Phải có Đấng Sáng Tạo muôn loài, và là Đấng ban hạnh phúc cho loài người thì cuộc đời mới trọn ý nghĩa. Xin Chúa thêm niềm hăng say để con kiên trì học biết Chúa.
`
},
  {
  id: 2,
  title: "Thiên Chúa nói với loài người",
  tag: "CHƯƠNG I",
  desc: "Thiên Chúa mặc khải và chương trình cứu độ trong Thánh Kinh.",
  content: `#  I. LỜI CHÚA
“Thiên Chúa cho ta được biết thiên ý nhiệm mầu: Thiên ý này là kế hoạch yêu thương Người đã định từ trước trong Đức Kitô.” (Ep 1,9)

#  II. TRÌNH BÀY

Loài người tìm kiếm Thiên Chúa, nhưng thực ra, chính Thiên Chúa tìm gặp loài người trước: Thiên Chúa gieo vào tâm hồn loài người một khát vọng tìm kiếm Người, rồi chính Người đến tỏ mình cho họ. Thiên Chúa tỏ mình cho loài người dưới nhiều hình thức, nhất là trong THÁNH KINH.

## 1. Thánh Kinh là gì?

Thánh Kinh là bộ sách cho chúng ta biết Thiên Chúa là ai và Người muốn chúng ta làm gì. Bộ sách này được Thiên Chúa soi sáng cho một số người viết ra. Những người này nhận được ánh sáng Thiên Chúa từ bên trong (linh ứng) để viết ra những điều Chúa muốn. Nói cách khác, các Thánh ký (Ngôn sứ, Tông đồ, một số môn đệ…) lãnh nhận điều Thiên Chúa soi sáng trong lòng, rồi trình bày bằng chữ viết theo cách thức riêng của mình. Như thế, có thể nói rằng: ý tưởng (nội dung) là do Thiên Chúa, còn hình thức (cách diễn tả) là do các Thánh ký. Sự phân chia này khiến nhiều người gọi Thiên Chúa là Tác-giả-chính của Thánh Kinh, còn các Thánh ký là Tác-giả-phụ: “Để viết các sách thánh, Thiên Chúa đã chọn một số người, dùng họ trong khả năng và phương tiện của họ, họ viết ra tất cả những gì Chúa muốn và chỉ viết những điều Chúa muốn mà thôi” (Hc. MK 11).

## 2. Thánh Kinh viết từ bao giờ?

Thánh Kinh được viết trong khoảng 12 thế kỷ từ năm 1250 trước công nguyên đến năm 100 sau công nguyên, gồm phần Cựu ước và Tân ước.

– Cựu ước: là những sách viết về giao ước ký kết xưa kia giữa Thiên Chúa và dân tộc Israel. Cựu ước có 46 cuốn.

– Tân ước: là những sách viết về giao ước ký kết sau này giữa Thiên Chúa và loài người qua Chúa Kitô. Tân ước gồm 27 cuốn.

Sau này, Hội Thánh duyệt lại các sách đó và tập hợp thành bộ sách gọi là Thánh Kinh mà chúng ta sử dụng ngày nay.

Ngoài những điều được ghi chép bằng văn tự gọi là THÁNH KINH, còn nhiều điều không được ghi chép trong bộ sách ấy, nhưng vẫn được truyền tụng và được Hội thánh Công nhận, gọi là THÁNH TRUYỀN. Thánh Kinh và Thánh Truyền là nền tảng niềm tin của Hội Thánh.

## 3. Nội dung Thánh Kinh

Nội dung Thánh Kinh là chương trình cứu độ của Thiên Chúa. Chương trình được thực hiện qua từng giai đoạn như sau:

– Thiên Chúa Tình yêu dựng nên trời đất muôn vật và loài người: loài người được Chúa chăm sóc đặc biệt, được Chúa cho sống hạnh phúc ngay từ đầu.

– Để tăng thêm hạnh phúc cho loài người, Thiên Chúa thử thách họ. Họ ngã gục. Hậu quả là họ phải sống lầm than, cay cực, phải chết, mất cả hy vọng được sống hạnh phúc đời sau. Tội của nguyên tổ ảnh hưởng tới toàn thể con cháu.

– Dù sao, Thiên Chúa đã dựng nên loài người, Người không nỡ cứ để họ sống trong khổ ải. Vì thế, Người hứa ban Đấng Cứu Thế đến cứu vớt họ, dạy họ biết cách sống để lại được làm con Chúa và đáng hưởng Nước Trời.

– Để chuẩn bị đón nhận Đấng Cứu Thế, Thiên Chúa chọn Israel làm dân riêng, huấn luyện, dạy dỗ, thanh tẩy họ. Quá trình tập huấn rất cam go. Thiên Chúa dùng các Quan án, các Vua, đặc biệt các Ngôn sứ rèn luyện họ, nhưng hầu hết họ vẫn tỏ ra bất xứng.

– Chỉ còn lại một số ít xứng đáng lãnh nhận ơn cứu độ, trong đó nổi bật khuôn mặt Đức Maria. Đức Maria được chọn gọi làm Mẹ Đấng Cứu Thế.

– Đấng Cứu Thế đến dạy dỗ loài người về tình thương của Chúa Cha, về cách thức loài người phải tôn thờ Thiên Chúa và đối xử với nhau. Vào cuối đời, Chúa Giêsu lấy chính máu mình ký kết với loài người một giao ước, thay thế giao ước cũ Sinai.

Chúa Giêsu cũng thiết lập Hội Thánh để tiếp tục công cuộc cứu chuộc của Người đã khởi sự ở trần gian. Sứ mệnh của Hội Thánh cũng chính là sứ mệnh của Chúa Kitô mà Hội Thánh phải thi hành không ngừng cho đến ngày tận thế: Lúc ấy, Chúa Kitô ngự đến trong vinh quang để phán xét toàn thể vũ trụ; cũng là lúc hoàn tất chương trình cứu độ. Người dâng lên cho Thiên Chúa Cha chiến lợi phẩm đáng giá là toàn thể thế giới đã được cứu chuộc. Ngày ấy thật đáng mong đợi. Vì thế, Hội Thánh hằng kêu xin với Chúa rằng: “Lạy Chúa, xin hãy đến” (Kh 22,20).

#  III. BÀI HỌC

**03. H. Thiên Chúa dùng cách thức nào để tỏ mình cho loài người?**

T. Thiên Chúa dùng nhiều cách thức, nhưng cách rõ ràng nhất là Thánh Kinh.

**04. H. Thánh Kinh là gì?**

T. Thánh Kinh là bộ sách được linh ứng ghi chép ý định và hành động cứu chuộc loài người của Thiên Chúa. Thánh Kinh gồm 46 cuốn Cựu ước và 27 cuốn Tân ước.

**05. H. Nội dung Thánh Kinh là gì?**

T. Nội dung Thánh Kinh là chương trình và hành động cứu độ của Thiên Chúa được Chúa Giêsu Kitô thực hiện. Chương trình và hành động này trải dài suốt lịch sử loài người.

#  IV. THÁI ĐỘ SỐNG

Thánh Kinh là bộ sách trình bày việc Thiên Chúa cứu độ loài người. Tôi là một người cần được cứu độ. Vậy tôi quyết làm quen với Thánh Kinh bằng việc đọc và suy niệm để hiểu rõ ý định của Thiên Chúa trên cuộc đời tôi.

#  V. CẦU NGUYỆN

Lạy Chúa, dù chưa được chính thức làm con Chúa, con vẫn đi dự Thánh lễ mỗi khi có thể. Trong Thánh lễ, mọi người chăm chú nghe đọc Thánh Kinh. Hôm nay, con mới hiểu Thánh Kinh là sách ghi lại Lời Chúa. Xin cho con biết quý mến Thánh Kinh, năng đọc và chăm chú nghe Lời Chúa.`
},
{
  id: 3,
  title: "Đón nhận Lời Chúa",
  tag: "CHƯƠNG I",
  desc: "Thái độ đón nhận và cách đọc Thánh Kinh trong đời sống Kitô hữu.",
  content: `#  I. LỜI CHÚA

“Lời Thiên Chúa là Lời sống động, hữu hiệu và sắc bén hơn cả gươm hai lưỡi” (Hr 4,12),  
“là Lời ban ân sủng, Lời có thể xây dựng và ban cho anh em được hưởng phần gia tài cùng với tất cả những người đã được thánh hiến.” (Cv 20,32)

---

#  II. TRÌNH BÀY

Thiên Chúa đã tỏ mình cho loài người cách chắc chắn qua Thánh Kinh.  
Nhờ Thánh Kinh, chúng ta biết được Thiên Chúa là ai, Người yêu thương ta thế nào và ta phải làm gì để đáp lại tình yêu ấy.

##  Chúng ta phải có thái độ nào đối với Thánh Kinh?

Chúng ta phải đón nhận Thánh Kinh trong tâm tình vui mừng, tạ ơn và ước muốn được Lời Chúa dạy dỗ.

- **Vui mừng**: vì Lời Chúa là lời tình yêu. Vì yêu thương, Chúa mời gọi chúng ta đến với Người để được sống hạnh phúc trong gia đình của Người.

- **Tạ ơn**: vì Thiên Chúa cao cả đã ban cho loài người những phương tiện chắc chắn để nhận biết, yêu mến và phụng thờ Người.

- **Ước muốn được dạy dỗ**:  
“mọi sự trong Thánh Kinh được Thiên Chúa linh ứng có ích lợi cho việc dạy dỗ, biện bác, sửa trị và rèn luyện trong công chính…” (2 Tm 1,16-17)

---

##  Ta phải đọc Thánh Kinh thế nào?

### a. Đọc trong đức tin với tâm tình khiêm tốn, đơn sơ

“Lạy Chúa, xin hãy phán, vì tôi tớ Chúa đang lắng tai nghe” (1 Sm 3,10)

“Hạnh phúc thay kẻ lắng nghe và tuân giữ Lời Thiên Chúa” (Lc 11,28)

### b. Đọc trong Hội Thánh

Phải đọc theo sự hướng dẫn của Hội Thánh, không theo ý kiến cá nhân, nhất là trong những điểm khó hiểu.

---

#  III. BÀI HỌC

**06. H. Ta phải đón nhận Thánh Kinh thế nào?**  
T. Ta phải đón nhận Thánh Kinh trong tâm tình vui mừng, tạ ơn.

**07. H. Ta phải đọc Thánh Kinh thế nào?**  
T. Ta phải đọc trong đức tin, khiêm tốn, đơn sơ, theo sự hướng dẫn của Hội Thánh, trong ước muốn được dạy dỗ và sẵn sàng thực hiện điều Chúa dạy.

---

#  IV. THÁI ĐỘ SỐNG

Vì yêu thương, Thiên Chúa gặp gỡ loài người.  
Người nói với tôi qua Thánh Kinh.  
Tôi đón nhận Lời Người trong tâm tình vui mừng, tạ ơn và quyết tâm để Lời Chúa sinh hoa trái trong đời tôi.

---

#  V. CẦU NGUYỆN

Lạy Chúa, Thánh Kinh là ánh sáng soi cho đời sống con.  
Xin cho con thành tâm lắng nghe và biết sống theo Lời Chúa dạy bảo.
`
},
{
  id: 4,
  title: "Thiên Chúa dựng nên trời đất muôn vật và loài người",
  tag: "CHƯƠNG I",
  desc: "Thiên Chúa là Đấng Tạo Thành vũ trụ, loài người và các thụ tạo vô hình.",
  content: `#  I. LỜI CHÚA

“Thiên Chúa phán: Chúng ta sẽ làm ra con người theo hình ảnh Chúng ta, giống như Chúng ta, để con người làm chủ cá biển, chim trời, gia súc, dã thú, tất cả mặt đất và mọi giống vật bò dưới đất.” (Kn 1,26)

---

#  II. TRÌNH BÀY

Vào một lúc nào đó trong cuộc đời, nhiều người tự hỏi:  
Loài người bởi đâu mà có? Tôi sống để làm gì? Chết rồi đi đâu? Trời đất tự nhiên mà có sao?

Khoa học, triết học, tôn giáo đều cố gắng trả lời những vấn nạn ấy.

Đạo Công giáo, dựa vào mạc khải, xác tín rằng:

---

##  Vũ trụ bởi Thiên Chúa mà có

- Thiên Chúa **dựng nên** vũ trụ từ hư vô.  
  “Dựng nên” khác với “chế tạo”:  
  - Chế tạo: dùng vật liệu có sẵn.  
  - Dựng nên: từ không làm cho có.  
  Chỉ Thiên Chúa mới có quyền năng ấy.

- Thánh Kinh dạy rằng cả sự sống trên trái đất cũng do Thiên Chúa dựng nên.

- Vũ trụ được dựng nên vì loài người và cho loài người:  
  Là nơi cư ngụ, là nguồn nuôi sống con người.

---

##  Thế còn loài người?

Loài người cũng do Thiên Chúa dựng nên.

Thánh Kinh diễn tả: Thiên Chúa lấy bụi đất nặn nên thân xác và hà hơi cho sống động — nghĩa là con người gồm **hồn và xác**.

- Xác: vật chất, sẽ tiêu tan.  
- Linh hồn: thiêng liêng và bất tử.

###  Con người là hình ảnh Thiên Chúa

“Chúng ta sẽ làm ra con người theo hình ảnh Chúng ta” (Kn 1,26)

Điều này cho thấy:
- Thiên Chúa đặc biệt quan tâm đến con người.
- Con người có phẩm giá rất cao quý.

### a. Con người giống Thiên Chúa vì có:
- Lý trí  
- Ý chí  
- Tự do (nên có trách nhiệm)

### b. Người nữ cũng do Thiên Chúa dựng nên  
Có cùng phẩm giá và bình đẳng với người nam.

### c. Hôn nhân  
Là cách thế tự nhiên giúp đôi bạn phát triển nhân cách, xây dựng xã hội và Hội Thánh.

---

###  Con người được tham dự hạnh phúc Thiên Chúa

- Đời này:  
  Sống và thực hiện thánh ý Thiên Chúa, xây dựng thế giới tốt đẹp hơn, sống yêu thương.

- Đời sau:  
  Hưởng hạnh phúc vĩnh cửu với Thiên Chúa.

Như vậy, con người là chủ thế giới hữu hình, có sứ mệnh nhận biết, yêu mến và tôn thờ Thiên Chúa.

---

##  Ngoài tạo vật hữu hình còn có gì nữa?

Thiên Chúa còn dựng nên **các Thiên Thần** (thụ tạo vô hình).

- Các Thiên Thần thờ phượng và thi hành mệnh lệnh Thiên Chúa.
- Một số đã phản loạn — gọi là Ma Quỷ.

“Anh em hãy sống tiết độ và tỉnh thức, vì ma quỷ như sư tử gầm thét, rảo quanh tìm mồi cắn xé.” (1 Pr 5,8-9)

---

#  III. BÀI HỌC

**08. H. Trời đất muôn vật bởi đâu mà có?**  
T. Trời đất muôn vật bởi Thiên Chúa dựng nên.

**09. H. Loài người là loài nào?**  
T. Loài người là loài có linh hồn và xác, được dựng nên giống hình ảnh Thiên Chúa, cho làm chủ vũ trụ và hưởng hạnh phúc đời đời.

---

#  IV. THÁI ĐỘ SỐNG

Tôi xác tín mình có phẩm giá cao quý vì được dựng nên theo hình ảnh Thiên Chúa.  
Tôi quyết tâm sống ngay thẳng và bảo vệ sự sống.

---

#  V. CẦU NGUYỆN

Lạy Chúa, Chúa dựng nên chúng con theo hình ảnh Chúa.  
Xin cho chúng con biết sống xứng đáng phẩm giá làm người và làm con Chúa. Amen.
`
},
 {
    id: 5,
    title: "Loài người sa ngã – Tội – Lời hứa cứu độ",
    tag: "CHƯƠNG I",
    desc: "Con người được dựng nên tốt lành nhưng đã sa ngã vì bất tuân. Thiên Chúa vẫn hứa ban Đấng Cứu Độ.",
    content: `
#  I. LỜI CHÚA

“Ta sẽ gây mối thù giữa mi và người đàn bà, giữa dòng giống mi và dòng giống người ấy; dòng giống đó sẽ đánh vào đầu mi, và mi sẽ cắn vào gót nó.” (Kn 3,15)

---

# II. TRÌNH BÀY

## 1. Hạnh phúc ban đầu

Sau khi dựng nên loài người, Thiên Chúa cho ở trong vườn địa đàng.  
“Thiên Chúa trồng một vườn cây ở Eden, khiến mọc lên từ đất đai đủ mọi thứ cây trông thì đẹp, ăn thì ngon với cây trường sinh ở giữa vườn” (Kn 2,8-9).

Ở tình trạng nguyên thủy này, loài người:
- Có trí khôn minh mẫn  
- Ý chí hướng về điều lành  
- Không phải đau khổ  
- Không phải chết  

---

## 2. Loài người sa ngã

Thiên Chúa đặt nguyên tổ Ađam – Evà trong tình trạng thử thách để biểu lộ lòng vâng phục.

Hình ảnh “con rắn và trái cấm” mô tả cuộc thử thách đó.

Ông bà đã sa ngã.  
Căn bản của tội này là:

> Tạo vật không tuân phục Tạo Hóa.

Satan cám dỗ:
“Không chết đâu… sẽ được bằng Thiên Chúa.”

Tội kiêu ngạo muốn bằng Thiên Chúa làm đảo lộn cuộc sống:
- Bị đuổi khỏi vườn địa đàng  
- Phải đau khổ  
- Phải chết  
- Mất tình thân với Thiên Chúa  

---

## 3. Tội

Tội của nguyên tổ gọi là **TỘI TỔ TÔNG**.

Hậu quả:
- Mất ơn nghĩa làm con Chúa  
- Lý trí tối tăm  
- Ý chí suy nhược  
- Dễ nghiêng chiều về điều xấu  

Con người tiếp tục phạm:
- Kiêu ngạo  
- Hà tiện  
- Dâm dục  
- Hờn giận  
- Mê ăn uống  
- Ghen ghét  
- Lười biếng  

Ngoại trừ Đức Maria được gìn giữ khỏi tội tổ tông, tất cả loài người đều mắc tội này.

Con người sinh ra:
- Mắc tội tổ tông  
- Có tội riêng  

---

## 4. Lời hứa cứu độ

Dù phạt nguyên tổ, Thiên Chúa vẫn thương xót và hứa ban ơn cứu độ:

“Ta sẽ gây mối thù giữa mi và người đàn bà…” (Kn 3,15)

Lời này ám chỉ:
- Đức Giêsu Kitô  
- Con của Đức Maria  
- Đấng Cứu Thế được loan báo trong Cựu Ước  

---

# III. BÀI HỌC

**10. H. Thiên Chúa đã ban cho nguyên tổ cuộc sống nào?**  
T. Thiên Chúa ban cho nguyên tổ cuộc sống được làm con Chúa và nhiều đặc ân khác.

**11. H. Nguyên tổ có được hạnh phúc ấy mãi không?**  
T. Không, vì nguyên tổ đã trái lệnh Chúa nên mất hạnh phúc và chuốc hậu quả cho mình và con cháu.

**12. H. Tội là gì?**  
T. Tội là lỗi luật Chúa và Hội Thánh trong tư tưởng, lời nói, việc làm và điều thiếu sót.

**13. H. Thiên Chúa có thái độ nào khi nguyên tổ phạm tội?**  
T. Thiên Chúa nghiêm phạt nhưng vẫn thương xót và hứa ban ơn cứu độ.

---

# IV. THÁI ĐỘ SỐNG

Tôi nhận thấy mình còn nhiều yếu đuối và tội lỗi.  
Tôi quyết sống khiêm nhường, cẩn trọng và tin tưởng vào lòng thương xót Chúa.

---

# V. CẦU NGUYỆN

Lạy Chúa,  
Con không dám trách nguyên tổ nữa,  
vì chính con cũng đầy lỗi lầm.

Xin Chúa tha thứ và giúp con cải thiện đời sống,  
để xứng đáng hưởng ơn cứu độ.  
Amen.
`
  },
{
  id: 6,
  title: "Thiên Chúa chọn các Tổ phụ và lập dân riêng",
  tag: "CHƯƠNG I",
  desc: "Thiên Chúa chọn Abraham, giải thoát dân Israel và lập giao ước để chuẩn bị Đấng Cứu Thế.",
  content: `#  I. LỜI CHÚA

“Đức Chúa phán với ông Ap-ram: ‘Hãy rời bỏ xứ sở, họ hàng và nhà cha ngươi, mà đi tới đất Ta sẽ chỉ cho ngươi. Ta sẽ làm cho ngươi thành một dân lớn, sẽ chúc phúc cho ngươi. Nhờ ngươi, mọi gia tộc trên mặt đất sẽ được chúc phúc.’” (Kn 12,1-3)

---

#  II. TRÌNH BÀY

Tình thương cứu độ phải đến với từng người. Tuy nhiên, Thiên Chúa không muốn cứu độ loài người một cách riêng rẽ, nhưng muốn quy tụ họ thành một dân tộc để họ nhận biết và phụng sự Người.

Khoảng 2000 năm trước Công nguyên, Thiên Chúa bắt đầu kế hoạch cứu độ bằng việc chọn gọi Tổ phụ Abraham.

---

##  Các Tổ phụ

### a. Abraham

Abraham sống tại Mêsôpôtamia khoảng 1800 năm trước Công nguyên.  
Thiên Chúa gọi ông rời bỏ quê hương để đến đất Canaan.

Ông đã vâng phục, dù phải trải qua thử thách lớn là hiến tế con mình là Isaac. Vì lòng tin vững mạnh, ông được gọi là:

>  “Cha của những kẻ tin”

Ông trở thành Tổ phụ dân Israel – dân riêng Thiên Chúa.

---

### b. Giacóp (Israel)

Giacóp là cháu Abraham.  
Thiên Chúa đổi tên ông thành **Israel**.

Ông có 12 người con trai – tổ tiên 12 chi tộc Israel.

Do nạn đói, gia đình ông di cư sang Ai Cập và bị làm nô lệ hơn 400 năm.

---

### c. Môsê

Thiên Chúa sai Môsê giải thoát dân Israel khỏi Ai Cập.

Biến cố quan trọng:

- Tiệc Vượt Qua
- Máu chiên bôi lên cửa
- Biển Đỏ rẽ đôi

Sau đó, tại núi Sinai:

- Thiên Chúa lập giao ước
- Ban 10 điều răn
- Thành lập dân riêng có tổ chức

---

##  Thành lập dân riêng

Sau khi vào đất hứa:

- Thiên Chúa hướng dẫn dân qua các Thẩm phán
- Rồi đến các vua
- Nổi bật nhất là vua Đavit

Thiên Chúa hứa với Đavit:

> Một người trong dòng dõi ông sẽ làm vua muôn đời  
> 👉 Chính là Đấng Cứu Thế

---

#  III. BÀI HỌC

**14. Hỏi:** Thiên Chúa bắt đầu công cuộc cứu chuộc thế nào?  
**Thưa:** Thiên Chúa chọn gọi Abraham làm Tổ phụ dân riêng.

**15. Hỏi:** Thiên Chúa chọn gọi Môsê khi nào?  
**Thưa:** Khi dân Israel làm nô lệ ở Ai Cập để giải phóng họ.

**16. Hỏi:** Khi vào đất hứa, dân Israel được hướng dẫn thế nào?  
**Thưa:** Qua các Thẩm phán rồi đến các vua, nổi bật là vua Đavit.

**17. Hỏi:** Thiên Chúa hứa gì với Đavit?  
**Thưa:** Một triều đại bền vững và một người trong dòng dõi ông sẽ làm vua mãi mãi – Đấng Cứu Thế.

---

#  IV. THÁI ĐỘ SỐNG

Để xứng đáng lãnh nhận Chúa Cứu Thế, loài người phải được chuẩn bị lâu dài.  
Tôi quyết tâm dùng thời gian dự tòng này sửa soạn trí khôn và tâm hồn.

---

#  V. CẦU NGUYỆN

Lạy Chúa, chính Chúa thành lập và hướng dẫn dân riêng.  
Ngày chịu phép Rửa tội, con được gia nhập dân Chúa.  
Xin giúp con biết tuân theo Hội Thánh để xứng đáng là công dân Nước Trời.
`
},
{
  id: 7,
  title: "Thiên Chúa thiết lập Giao Ước và ban lề luật",
  tag: "CHƯƠNG I",
  desc: "Thiên Chúa lập giao ước tại Sinai và ban lề luật để hướng dẫn dân sống thánh thiện.",
  content: `#  I. LỜI CHÚA

“Thiên Chúa phán: ‘Các ngươi thấy Ta đã mang các ngươi như trên cánh chim bằng mà đem đến với Ta. Vậy giờ đây, nếu các ngươi thực sự nghe tiếng Ta và giữ giao ước của Ta, thì giữa hết mọi dân, các ngươi sẽ là sở hữu riêng của Ta. Ta sẽ coi các ngươi là một vương quốc tư tế, một dân thánh dành riêng cho Ta.’

Toàn dân nhất trí đáp lại: ‘Mọi điều Đức Chúa phán bảo, chúng tôi xin làm theo.’” (Xh 19,4-8)

---

#  II. TRÌNH BÀY

Khi ra khỏi Ai Cập, Israel còn là một nhóm dân ô hợp, chưa có tổ chức.  
Thiên Chúa thiết lập GIAO ƯỚC và ban LỀ LUẬT để họ trở thành một dân tộc có trật tự và thánh thiện.

---

##  Thiết lập Giao Ước

Giao ước là lời cam kết đôi bên, bao gồm quyền lợi và nghĩa vụ.

Tại núi Sinai:

-  Thiên Chúa nhận Israel làm dân riêng.
-  Israel cam kết tôn thờ một mình Thiên Chúa và vâng giữ luật Người.

Lời đáp của dân:

> “Mọi điều Đức Chúa phán bảo, chúng tôi xin làm theo.”

Đây là nền tảng đời sống tôn giáo và chính trị của Israel.  
Vận mệnh dân tộc tùy thuộc vào sự trung thành với giao ước.

Lịch sử cho thấy Israel nhiều lần bất trung.  
Vì thế, một Giao Ước Mới sẽ được thiết lập trong Máu Chúa Kitô.

---

##  Ban Lề Luật

Cùng với giao ước, Thiên Chúa ban lề luật để dân sống hạnh phúc.

Luật được ghi trong **Ngũ Thư** gồm:

- Khởi Nguyên
- Xuất Hành
- Lêvi
- Dân Số
- Thứ Luật

Nhờ luật:

- Israel biết thờ phượng Thiên Chúa đúng cách
- Biết yêu thương tha nhân
- Thảo kính cha mẹ
- Tôn trọng danh dự và tài sản người khác
- Giữ mình là hình ảnh Thiên Chúa

Lề luật được ban vì hạnh phúc con người:

> “Xin cho tôi vững bước đi trên nẻo đường lệnh truyền vì nó là nguồn vui sống của tôi.” (Tv 119,35)

---

#  III. BÀI HỌC

**18. Hỏi:** Thiên Chúa đã ký kết gì với Israel?  
**Thưa:** Thiên Chúa ký kết một GIAO ƯỚC tại núi Sinai.

**19. Hỏi:** Thiên Chúa cam kết gì với Israel?  
**Thưa:** Nhận Israel làm dân riêng, chăm sóc và hướng dẫn vận mệnh họ.

**20. Hỏi:** Israel cam kết gì với Thiên Chúa?  
**Thưa:** Tôn thờ Thiên Chúa duy nhất và giữ mọi luật Người truyền.

**21. Hỏi:** Luật Môsê được ghi ở đâu?  
**Thưa:** Trong Ngũ Thư: Khởi Nguyên, Xuất Hành, Lêvi, Dân Số và Thứ Luật.

**22. Hỏi:** Luật Môsê gồm những gì?  
**Thưa:** Gồm các giáo huấn, mệnh lệnh và ý định của Thiên Chúa giúp dân biết sống đúng đắn.

---

#  IV. THÁI ĐỘ SỐNG

Qua giao ước Sinai, tôi nhận biết Thiên Chúa đòi hỏi lòng trung thành.  
Tôi quyết tâm thực hiện mọi lời cam kết với Chúa.

---

#  V. CẦU NGUYỆN

Lạy Chúa, Chúa đã tỏ cho con biết giao ước và lề luật của Chúa.  
Con biết đó là điều tốt lành và dẫn đến hạnh phúc.  
Xin giúp con yêu mến và thi hành giới răn Chúa mỗi ngày.
`
},
{
  id: 8,
  title: "Thiên Chúa chọn gọi các Ngôn sứ",
  tag: "CHƯƠNG I",
  desc: "Thiên Chúa chọn và sai các Ngôn sứ đến hướng dẫn dân Israel trung thành với giao ước và loan báo Đấng Cứu Thế.",
  content: `#  I. LỜI CHÚA

“Thiên Chúa phán: này Ta sai sứ giả của Ta đi trước Con, để dọn đường cho Con đến.” (Mc 1,2; Mt 3,1)

---

#  II. TRÌNH BÀY

Thiên Chúa đã chọn gọi và sai các Ngôn sứ đến với dân Israel để tiếp tục huấn luyện họ trung thành với giao ước và xứng đáng lãnh nhận Đấng Cứu Thế đã hứa.

##  Ngôn sứ là ai?

Ngôn sứ, theo tiếng Hipri – “na-bi” – có nghĩa là “người được gọi, người loan báo”, như trường hợp của Êlia, Isaia, Giêrêmia, Êzêkiel… Thiên Chúa đã tuyển chọn các ngài như những người thân thiết của Chúa để truyền đạt Lời Người cho dân riêng:

- Khi dân đi sai đường lối Chúa, các Ngôn sứ nhắc nhở, khuyến cáo họ trở về cùng Thiên Chúa.  
- Khi dân cố chấp trong đường lối sai lầm, các Ngôn sứ đe loi, tiên báo các tai họa sẽ đến.  
- Trong thời lưu đày, khi dân thất vọng buông xuôi, Ngôn sứ kêu gọi họ luôn tin tưởng vào Thiên Chúa.  
- Khi dân mệt mỏi vì mong chờ Đấng Cứu Thế, Ngôn sứ loan báo ngày Đấng Thiên Sai sẽ đến thực hiện ơn cứu độ.

##  Nội dung chính của sứ điệp các Ngôn sứ

### a) Nhắc nhở dân tuân giữ giao ước

Ngôn sứ cảnh tỉnh dân và đòi buộc họ phải trở về tuân giữ giao ước đã ký với Thiên Chúa. Qua các Ngôn sứ, Thiên Chúa giáo dục dân và tuyên hứa sẽ ban Đấng Thiên Sai và Nước Thiên Chúa.

### b) Loan báo ơn cứu độ

Các Ngôn sứ loan báo ơn cứu độ Thiên Chúa đã hứa từ ngàn xưa, với những chi tiết cụ thể:

- Sinh bởi một Trinh Nữ (x. Is 7,14).  
- Sinh tại Bêlem, thành vua Đavit (x. Mic 5,2).  
- Chữa người mù, què, câm, điếc; rao giảng Tin Mừng cho người nghèo; loan báo năm Hồng ân (x. Is 61).  
- Đấng Cứu Thế sẽ chịu đau khổ, chết và sống lại (x. Is 53).

##  Số lượng các Ngôn sứ

Thánh Kinh Cựu Ước ghi nhận 16 Ngôn sứ, trong đó 4 vị lớn là Isaia, Giêrêmia, Êzêkiel và Daniel.

Gioan Tẩy Giả là vị Ngôn sứ nối kết thời Cựu Ước với thời Tân Ước. Vinh dự lớn nhất của ông là được thấy và giới thiệu Chúa Cứu Thế cho người đương thời.

---

#  III. BÀI HỌC

**23. H. Ngôn sứ là ai?**  
T. Ngôn sứ là những người được Thiên Chúa chọn để sai đi loan truyền Lời Chúa cho dân Người.

**24. H. Các Ngôn sứ đã nói gì với dân Chúa?**  
T. Các Ngôn sứ đã nói những điều chính yếu này:  
- Nhắc nhở dân nhớ các điều họ đã cam kết với Thiên Chúa trong giao ước.  
- Loan báo ơn cứu độ Thiên Chúa sẽ thực hiện qua Đấng Cứu Thế.

---

#  IV. THÁI ĐỘ SỐNG

Xưa kia, dân Israel được các Ngôn sứ dạy dỗ chuẩn bị đón nhận Đấng Cứu Thế. Ngày nay, tôi sẵn sàng nghe lời hướng dẫn của các thừa tác viên trong Hội Thánh.

---

#  V. CẦU NGUYỆN

Lạy Chúa, Chúa hằng sai các sứ giả đến hướng dẫn dân Chúa. Xin cho con biết mau mắn đón nhận lời giảng dạy của Hội Thánh.
`
},
{
  id: 9,
  title: "Chúa Giêsu sinh ra",
  tag: "CHƯƠNG I",
  desc: "Mầu nhiệm Nhập Thể và biến cố Giáng Sinh – Con Thiên Chúa xuống thế làm người để cứu độ nhân loại.",
  content: `#  I. LỜI CHÚA

“Ngôi Lời đã làm người và ở giữa chúng ta. Chúng ta đã được nhìn thấy vinh quang của Người. Vinh quang mà Chúa Cha ban cho Người là Con Một đầy tràn ân sủng và chân lý.” (Ga 1,14)

---

#  II. TRÌNH BÀY

Lời Thiên Chúa hứa ban Đấng Cứu Thế tại vườn địa đàng xưa kia cuối cùng đã được thực hiện.

##  Truyền Tin

Sứ thần Gabriel hiện đến với Trinh Nữ Maria và chào:

“Mừng vui lên, hỡi Bà đầy ơn phúc. Đức Chúa ở cùng Bà” (Lc 1,28).

Maria bỡ ngỡ trước lời chào đó. Sứ thần nói:

“Bà đừng sợ, Bà sẽ làm Mẹ một Hài nhi, đặt tên là Giêsu. Người sẽ nên cao trọng và là Con Thiên Chúa.”

Khi hiểu đó là thánh ý Thiên Chúa, Mẹ Maria thưa:

“Vâng, tôi đây là nữ tỳ của Chúa, xin làm cho tôi như lời Sứ thần nói.”

Ngay sau tiếng **XIN VÂNG**, Ngôi Hai xuống thế làm người.

Biến cố này ứng nghiệm lời Ngôn sứ Isaia:

“Một Trinh Nữ sẽ thụ thai, sinh một con trai, gọi là Emmanuel” (Is 7,14).

---

##  Giáng Sinh

Lễ Giáng Sinh là đại lễ mừng Con Thiên Chúa giáng trần.

Nhưng đêm Chúa ra đời thật nghèo nàn và giá lạnh.

Theo lệnh Hoàng đế Augustô, dân phải về nguyên quán đăng ký hộ khẩu.

Ông Giuse dẫn Maria đang mang thai về Bêlem vì thuộc dòng tộc Đavit. Thành đông đúc, hai ông bà không tìm được quán trọ, đành trú trong chuồng súc vật.

Giữa đêm, Maria hạ sinh Hài nhi, quấn tã và đặt nằm trong máng cỏ.

Các mục đồng được thiên thần báo tin và đã đến thờ lạy.

Trên trời vang lên lời ca:

“Vinh danh Thiên Chúa trên trời  
Bình an dưới thế cho người thiện tâm.”

Ít lâu sau, các Đạo sĩ từ phương Đông đến kính viếng và dâng lễ vật.

Sau đó, Thánh Gia phải trốn sang Ai Cập vì vua Hêrôđê tìm giết Hài nhi.

---

##  Vì sao người Kitô hữu mừng lễ Giáng Sinh trọng thể?

### a) Vì các Ngôn sứ đã loan báo trước

- Sinh tại Bêlem (Mi 5,1)  
- Sinh bởi Trinh Nữ (Is 7,14)  
- Mang tên Emmanuel  

### b) Vì Chúa Giêsu chính là Đấng Cứu Thế

Khi suy ngắm đời sống, lời giảng, phép lạ và nhất là cái chết trên thập giá của Người, tín hữu cảm nhận sâu xa tình yêu Thiên Chúa.

Vì thế, ngày Chúa sinh ra được mừng hết sức long trọng.

---

#  III. BÀI HỌC

**25. H. Thiên Chúa sai sứ thần Gabriel loan tin gì cho Đức Maria?**  
T. Loan báo rằng Đức Maria sẽ thụ thai, sinh một Con trai và đặt tên là Giêsu (Lc 1,31).

**26. H. Lễ Giáng Sinh là lễ nào?**  
T. Là lễ người Kitô hữu mừng kỷ niệm Chúa Giêsu sinh ra ở Bêlem.

**27. H. Ta phải có tâm tình nào khi mừng lễ Giáng Sinh?**  
T. Phải cảm mến tình Chúa yêu ta và biết yêu thương mọi người.

---

#  IV. THÁI ĐỘ SỐNG

Như các Đạo sĩ đã vượt đường xa tìm đến thờ lạy Chúa, tôi cũng phải vượt qua khó khăn để kiên trì tìm kiếm Chúa trong đời sống.

---

#  V. CẦU NGUYỆN

Lạy Chúa, dù chưa được diễm phúc vào Đạo, con đã cảm thấy vui sướng khi dự lễ Giáng Sinh. Xin cho con sớm trở thành con Chúa để hưởng trọn niềm vui ngày Con Chúa giáng trần.
`
},
{
  id: 10,
  title: "Chúa Giêsu sống ẩn dật",
  tag: "CHƯƠNG I",
  desc: "Ba mươi năm âm thầm tại Nazareth – đời sống gia đình, lao động và vâng phục của Chúa Giêsu.",
  content: `#  I. LỜI CHÚA

“Chúa Giêsu theo cha mẹ trở về Nazareth và hằng vâng phục các Ngài, ngày càng khôn lớn và được Thiên Chúa cũng như mọi người thương mến.” (Lc 2,51-52)

---

#  II. TRÌNH BÀY

Khi nghe tin Hêrôđê qua đời, thánh Giuse và Đức Mẹ đưa Chúa Giêsu trở về Palestina và lập cư tại Nazareth.

##  Gia đình thánh tại Nazareth

Đây là một gia đình nghèo: thánh Giuse, người gìn giữ Đấng Cứu Thế, làm nghề thợ mộc. Mẹ Maria lo việc nội trợ.  

Chúa Giêsu lớn lên trong cảnh đơn nghèo, được giáo dục như các trẻ cùng trang lứa, nhất là học hỏi Thánh Kinh. Người học nghề thợ mộc với thánh Giuse.  

Người có tâm hồn yêu thiên nhiên, yêu quê hương, yêu cuộc sống, thích quan sát sinh hoạt hằng ngày. Những bài giảng sau này, nhất là các dụ ngôn, chứng tỏ Chúa Giêsu có tâm hồn đáng quý như thế.

---

##  Biến cố Chúa Giêsu ở lại Giêrusalem

Năm ấy, lúc 12 tuổi, Chúa Giêsu theo thánh Giuse và Đức Maria lên Đền thờ mừng lễ Vượt Qua.

Khi lễ hội kết thúc, mọi người trở về nhà. Sau một ngày đường, thánh Giuse và Đức Maria mới nhận ra không thấy Chúa Giêsu đâu. Hai ông bà hoảng hốt tìm kiếm và phải quay lại Đền thờ.

Ba ngày sau, các Ngài thấy Chúa Giêsu đang ngồi giữa các thầy luật sĩ, lắng nghe và đặt câu hỏi.

Đức Mẹ nói:  
“Con ơi, sao con làm khổ cha mẹ như vậy? Con thấy không, cha con và mẹ đã phải cực lòng tìm con.”  

Chúa Giêsu đáp:  
“Sao cha mẹ lại tìm con? Cha mẹ không biết là con có bổn phận ở nhà của Cha con sao?” (Lc 2,48-49)

Câu trả lời này lúc đó hai ông bà chưa hiểu hết.

Sau đó, Chúa Giêsu theo cha mẹ trở về Nazareth và hằng vâng phục các Ngài.

---

##  Cuộc sống âm thầm của Thánh Gia dạy ta điều gì?

Đời sống Nazareth dạy ta:

- Biết yêu quý đời sống bình dị, đơn sơ  
- Yêu lao động và siêng năng làm việc  
- Mến chuộng đời sống gia đình  
- Chu toàn bổn phận đối với cha mẹ và Thiên Chúa  

Ba mươi năm âm thầm tại Nazareth ví như thời gian gieo giống. Chúa Giêsu là hạt giống mà Chúa Cha âm thầm gieo vào thế gian. Hạt giống ấy lớn lên, sinh hoa kết trái và trở thành nguồn sự sống cho toàn thể nhân loại.

---

#  III. BÀI HỌC

**28. H. Gia đình Nazareth gồm những ai?**  
T. Gia đình Nazareth gồm thánh Giuse, Mẹ Maria và Chúa Giêsu.

**29. H. Chúa Giêsu làm gì ở Nazareth?**  
T. Chúa Giêsu luôn cầu nguyện, học hỏi Thánh Kinh, làm việc và vâng lời Đức Maria cùng thánh Giuse.

**30. H. Đời sống ẩn dật của Chúa Giêsu tại Nazareth dạy ta điều gì?**  
T. Dạy ta biết yêu cuộc sống bình dị, đơn giản, yêu lao động, chu toàn bổn phận đối với Thiên Chúa, cha mẹ và mọi người.

---

#  IV. THÁI ĐỘ SỐNG

Chúa Giêsu là Con Thiên Chúa mà đã sống vâng phục và khó nghèo trong gia đình Nazareth. Tôi quyết tâm xây dựng bầu khí thuận hòa, yêu thương trong gia đình mình.

---

#  V. CẦU NGUYỆN

Lạy Chúa, con được chiêm ngắm gia đình Chúa ở Nazareth đầy yêu thương và hạnh phúc. Xin cho gia đình con cũng được thuận hòa và chan chứa tình yêu thương.
`
},
{
  id: 11,
  title: "Chúa Giêsu rao giảng Nước Thiên Chúa",
  tag: "CHƯƠNG I",
  desc: "Chúa Giêsu khởi đầu sứ vụ công khai, rao giảng Tin Mừng và loan báo Nước Thiên Chúa đã gần đến.",
  content: `#  I. LỜI CHÚA

“Sau khi ông Gioan bị bắt giam, Đức Giêsu đến miền Galilê rao giảng Tin mừng của Thiên Chúa. Người nói: Thời kỳ đã mãn, và Nước Thiên Chúa đã gần rồi. Anh em phải sám hối và tin vào Tin mừng.” (Mc 1,14-15)

---

#  II. TRÌNH BÀY

Sau thời gian dài sống âm thầm tại Nazareth, Chúa Giêsu rời gia đình, đi rao giảng Tin mừng và thực hiện ơn cứu độ.

##  Gioan Tẩy Giả dọn đường

Ngôn sứ Gioan kêu gọi sám hối, làm Phép Rửa để dọn đường Chúa đến. Ông giới thiệu Chúa cho mọi người:

“Đây là Chiên Thiên Chúa, đây Đấng xóa tội trần gian” (Ga 1,29).

Rồi ông rút lui vào bóng tối, nhường chỗ cho Chúa Giêsu:

“Người phải nổi bật lên, còn Thầy phải lu mờ đi” (Ga 3,30).

---

##  Chúa Giêsu rao giảng ở đâu?

Chúa Giêsu được Thánh Thần dẫn vào sa mạc, ăn chay cầu nguyện 40 đêm ngày, chịu ma quỷ cám dỗ và toàn thắng.

Sau đó, Người rời sa mạc, đi khắp xứ Galilêa giảng về Nước Thiên Chúa. Tại Đền thờ Giêrusalem, Người công bố nhiều chân lý quan trọng về chính mình.

---

##  Nước Thiên Chúa là gì?

Chúa Giêsu rao giảng Nước Thiên Chúa đã gần đến, nhưng Người không định nghĩa rõ ràng mà dùng hình ảnh để diễn tả:

- Cánh đồng lúa mọc lẫn cỏ lùng  
- Hạt cải  
- Men trong bột  
- Kho báu  
- Ngọc quý  
- Lưới cá… (x. Mt 13)

Những hình ảnh đó cho thấy Nước Thiên Chúa là thực tại sống động và đang đến. Dấu hiệu Nước Thiên Chúa xuất hiện là việc Chúa xua trừ ma quỷ và chữa lành bệnh nhân.

---

##  Nước Thiên Chúa đã đến chưa?

Nước Thiên Chúa không còn là lời hứa xa xôi. Nước Thiên Chúa đã đến cùng với Chúa Giêsu. Chính Người thiết lập Nước Thiên Chúa nơi trần gian.

Ai tin, sám hối và đón nhận Người là đã bước vào Nước Thiên Chúa.

“Nước Thiên Chúa đã đến gần” (Mt 4,17).

---

##  Phải làm gì để đón nhận Nước Thiên Chúa?

Phải **sám hối** và **tin vào Tin Mừng**.

- **Sám hối**: hối hận về những điều sai trái đã làm và quyết tâm không tái phạm.
- **Tin vào Tin Mừng**: tin vào lời dạy của Chúa Giêsu và sống điều mình tin.

Tin không chỉ là chấp nhận bằng lý trí, nhưng là sống theo điều mình tin.

---

#  III. BÀI HỌC

**31. H. Gioan Tẩy Giả là ai?**  
T. Gioan Tẩy Giả là Ngôn sứ cuối cùng của thời Cựu ước, được Thiên Chúa chọn để dọn đường cho Chúa Cứu Thế.

**32. H. Khi bắt đầu rao giảng, Chúa Giêsu loan báo điều gì?**  
T. “Thời kỳ đã mãn và Nước Thiên Chúa đã gần đến rồi. Anh em phải sám hối và tin vào Tin mừng” (Mc 1,15).

**33. H. Chúa Giêsu đã giảng về Nước Thiên Chúa như thế nào?**  
T. Người dùng nhiều dụ ngôn để nói về Nước Thiên Chúa như: kho báu, mẻ lưới, men trong bột, hạt cải…

---

#  IV. THÁI ĐỘ SỐNG

Nước Thiên Chúa chỉ đến với những tâm hồn sám hối và tin vào Chúa Giêsu.  
Tôi quyết tâm học hỏi Lời Chúa và thay đổi nếp sống cho phù hợp với Tin Mừng.

---

#  V. CẦU NGUYỆN

Lạy Chúa, Chúa đến rao giảng Nước Thiên Chúa và mời gọi mọi người gia nhập. Xin cho con hiểu biết và đón nhận lời giảng của Hội Thánh để Nước Chúa hiển trị trong lòng con. Amen.
`
},
{
  id: 12,
  title: "Chúa Giêsu dạy ta về Ba Ngôi",
  tag: "CHƯƠNG I",
  desc: "Chúa Giêsu mặc khải mầu nhiệm Một Chúa Ba Ngôi: Chúa Cha, Chúa Con và Chúa Thánh Thần.",
  content: `#  I. LỜI CHÚA

“Khi Đức Giêsu đã chịu Phép Rửa xong, vừa ở dưới nước lên thì tầng trời bỗng mở ra. Người thấy Thần Khí Thiên Chúa đáp xuống như chim bồ câu và ngự trên Người. Và chợt có tiếng từ trời phán rằng: Đây là Con yêu dấu của Ta, Ta hài lòng về Người.” (Mt 3,16-17)

---

#  II. TRÌNH BÀY

Khi loan báo về Nước Thiên Chúa, Chúa Giêsu cũng dạy ta biết mầu nhiệm Thiên Chúa Ba Ngôi.

##  Chúa Giêsu dạy về Chúa Cha

Chúa Giêsu gọi Thiên Chúa là Cha của Người. Người hằng cầu khẩn Chúa Cha, tìm sống thánh ý Cha và chu toàn sứ mệnh Cha trao phó:

- “Lạy Cha là Chúa trời đất” (Mt 11,25).  
- “Lạy Cha, con cảm tạ Cha vì Cha đã nhậm lời con…” (Ga 11,41).  
- Tại vườn Cây Dầu: “Lạy Cha, nếu được, thì xin cho con khỏi uống chén đắng này. Nhưng xin đừng theo ý con, mà xin theo ý Cha” (Mt 26,39).

Vì tuyên bố Thiên Chúa là Cha và xưng mình là Con, Chúa Giêsu bị kết án tử hình vì “đã nói phạm thượng”.

---

##  Chúa Giêsu dạy về Chúa Thánh Thần

Chúa Giêsu nhiều lần nói về Chúa Thánh Thần, nhất là trong diễn từ chia ly:

- Người hứa sẽ gửi Thánh Thần đến sau khi về cùng Chúa Cha.  
- Người gọi Thánh Thần là Đấng Bảo Trợ (Ga 14,16).  
- Thánh Thần sẽ làm chứng cho Người và loan báo những điều sẽ xảy đến (Ga 16,13-14).

---

##  Chúa Giêsu dạy về chính mình

- “Ta và Cha là một” (Ga 10,30) – nghĩa là Người là Thiên Chúa như Chúa Cha.  
- Người được Chúa Cha sai đến trần gian để cứu độ loài người.  
- Người có quyền tha tội (Lc 5,24), một quyền năng thuộc về Thiên Chúa.  
- Người sống lại để chứng tỏ Người là Con Thiên Chúa, là Thiên Chúa thật.

---

##  Ba Ngôi nhưng một Chúa

Chúa Giêsu truyền cho các Tông đồ:

“Anh em hãy đi đến với muôn dân, làm Phép Rửa cho họ nhân danh Chúa Cha, Chúa Con và Chúa Thánh Thần” (Mt 28,19).

Cha là Thiên Chúa.  
Con là Thiên Chúa.  
Thánh Thần là Thiên Chúa.  

Ba Ngôi cùng là Thiên Chúa, nhưng không phải là ba Thiên Chúa, mà là **MỘT THIÊN CHÚA BA NGÔI**.

Đây là mầu nhiệm cao cả nhất trong Đạo. Ta không thể hiểu hết, nhưng ta tin vì chính Chúa Giêsu đã dạy như vậy.

---

##  Mầu nhiệm Ba Ngôi liên hệ với chúng ta

Thiên Chúa Ba Ngôi là nguồn gốc muôn loài:

- Ngôi Cha dựng nên vũ trụ.  
- Ngôi Con xuống thế cứu độ nhân loại.  
- Ngôi Thánh Thần ban và tăng cường sự sống thần linh nơi các tín hữu.

Vì thế, ta phải hết lòng cảm tạ và năng tưởng nhớ Ba Ngôi ngự trong lòng ta như Đền thờ của Người.

Kinh Sáng Danh và dấu Thánh Giá giúp ta tuyên xưng mầu nhiệm Ba Ngôi mỗi ngày.

---

#  III. BÀI HỌC

**35. H. Mầu nhiệm Một Chúa Ba Ngôi dạy ta điều gì?**  
T. Dạy ta biết có một Thiên Chúa mà Người có Ba Ngôi: Ngôi thứ Nhất là Cha, Ngôi thứ Hai là Con, Ngôi thứ Ba là Thánh Thần.

**36. H. Ta phải làm gì đối với Thiên Chúa Ba Ngôi?**  
T. Ta phải tin cậy, kính mến, thờ lạy và biết ơn, nhất là năng tưởng nhớ Ba Ngôi ngự trong lòng ta như Đền thờ của Người.

---

#  IV. THÁI ĐỘ SỐNG

Mỗi khi đọc kinh Sáng Danh và làm dấu Thánh Giá, tôi tuyên xưng mầu nhiệm Thiên Chúa Ba Ngôi. Tôi kính cẩn làm dấu Thánh Giá để tôn thờ Chúa Ba Ngôi.

---

#  V. CẦU NGUYỆN

Lạy Chúa, mầu nhiệm Một Chúa Ba Ngôi gợi lên trong trí con hình ảnh gia đình Ba Ngôi tràn đầy hạnh phúc. Xin cho con biết xây dựng gia đình mình trong yêu thương, để gia đình con trở nên hình ảnh Ba Ngôi trên trời. Amen.
`
},
{
  id: 13,
  title: "Tôn thờ Thiên Chúa",
  tag: "CHƯƠNG I",
  desc: "Con người được mời gọi thờ phượng, kính mến và giữ các điều răn của Thiên Chúa.",
  content: `#  I. LỜI CHÚA

“Nghe đây, hỡi Israel: Đức Chúa, Thiên Chúa chúng ta là Đức Chúa duy nhất. Hãy yêu mến Đức Chúa, Thiên Chúa anh em hết lòng, hết dạ, hết sức anh em.” (Tl 6,4-5)

---

#  II. TRÌNH BÀY

##  Tôn thờ là gì?

Tôn thờ là tâm tình và thái độ của loài người (thụ tạo) đối với Thiên Chúa (Tạo hóa): nhìn nhận sự sống và cái chết của mình hoàn toàn lệ thuộc vào Thiên Chúa.

Thái độ nội tâm ấy phải được thể hiện ra bên ngoài qua:
- Cầu nguyện  
- Tham dự Thánh lễ  
- Sống tuân phục Thiên Chúa  

Đó là nội dung của ba điều răn đầu trong Thập Giới.

---

##  Điều răn thứ nhất  
**Thờ phượng và kính mến Thiên Chúa trên hết mọi sự.**

Điều răn này nhấn mạnh đến thái độ nội tâm:

- Nhận biết mình do Thiên Chúa dựng nên  
- Được Người chuẩn bị hạnh phúc đời đời  
- Vì thế phải cảm tạ và yêu mến Chúa hết lòng  

Yêu mến Chúa hết lòng nghĩa là:
- Khi phải chọn giữa Thiên Chúa và tạo vật (tiền bạc, danh vọng, lạc thú…), ta chọn Chúa  
- Khi cần, sẵn sàng hy sinh mạng sống để trung thành với Chúa  

### ❌ Những lỗi phạm điều răn thứ nhất:
- Thờ các loài thụ tạo  
- Mê tín dị đoan  
- Phạm sự thánh  

---

##  Điều răn thứ hai  
**Chớ kêu vô cớ tên Thiên Chúa.**

Tên Thiên Chúa là thánh.

Ta không được:
- Kêu tên Chúa bừa bãi  
- Dùng tên Chúa để thề thốt vô lý  
- Nói danh Chúa thiếu kính trọng  

### ✅ Sống tích cực:
- “Nguyện Danh Cha cả sáng”  
- Kính cẩn khi đọc hoặc nghe danh Chúa  
- Loan báo Danh Chúa cho mọi người  

“Nghe danh Chúa Giêsu,  
Cả trên trời dưới đất  
Và trong cõi âm ty,  
Muôn vật phải bái quỳ...” (Phl 3,10)

---

##  Điều răn thứ ba  
**Giữ ngày Chúa Nhật**

### a. Tham dự Thánh lễ

- Thánh lễ là việc thờ phượng cao cả nhất  
- Chúa Nhật kỷ niệm Chúa Giêsu sống lại  
- Tham dự Thánh lễ là chu toàn nghĩa vụ cao cả nhất trong tuần  

Bỏ lễ Chúa Nhật không có lý do chính đáng là lỗi nặng.

---

### b. Kiêng việc xác

Kiêng việc xác là không làm những việc tay chân gây cản trở việc thánh hóa ngày Chúa Nhật.

Ý nghĩa:
- Tuân giữ lệnh truyền của Thiên Chúa  
- Mừng Chúa Phục Sinh  
- Chu toàn việc thờ phượng và bác ái  
- Bồi dưỡng sức khỏe sau tuần lao động  

Khi có lý do chính đáng vẫn có thể lao động, nhưng không được lạm dụng.

---

#  III. BÀI HỌC

**37. H. Thờ phượng Thiên Chúa là gì?**  
T. Là nhận biết Chúa là Cha đã sáng tạo và gìn giữ ta, nên ta phải hết lòng thờ kính, mến yêu và phụng sự Người.

**38. H. Điều răn thứ nhất dạy ta sự gì?**  
T. Dạy ta thờ phượng một Thiên Chúa và kính mến Người trên hết mọi sự.

**39. H. Điều răn thứ hai dạy ta sự gì?**  
T. Dạy ta tôn kính Chúa vì tên Người là thánh và là chính Người.

**40. H. Điều răn thứ ba dạy ta sự gì?**  
T. Dạy ta cử hành ngày Chúa Nhật bằng việc tham dự Thánh lễ, kiêng việc xác và làm các việc đạo đức, bác ái.

---

#  IV. THÁI ĐỘ SỐNG

Chúa là Đấng dựng nên tôi và hằng chăm sóc tôi.  
Vì thế, tôi quyết sống tin yêu và phó thác vào Thiên Chúa.

---

# 🕊 V. CẦU NGUYỆN

Lạy Chúa, Chúa đã dạy con phải tôn thờ Chúa.  
Xin cho con thành tâm yêu mến và trung thành giữ các giới răn Chúa.  
Amen.
`
},
{
  id: 14,
  title: "Tin – Cậy – Mến – Thờ phượng",
  tag: "CHƯƠNG I",
  desc: "Con người đáp lại tình yêu Thiên Chúa qua bốn nhân đức siêu nhiên: Tin – Cậy – Mến – Thờ phượng.",
  content: `#  I. LỜI CHÚA

“Hiện nay, Đức Tin, Đức Cậy, Đức Mến, cả ba đều tồn tại, nhưng cao trọng hơn là Đức Mến.” (1 Cr 13,13)

---

#  II. TRÌNH BÀY

Học tới đây bạn đã hiểu: vì yêu thương, Thiên Chúa đã sai Con của Ngài là Chúa Giêsu xuống trần gian, mời gọi loài người hãy sống làm con Chúa.  
Lời mời gọi ấy cần được đáp lại qua các thái độ và hành động siêu nhiên gọi là: **Tin – Cậy – Mến – Thờ phượng**.

---

## 🕊 A. TIN

###  Tin là gì?

Tin là việc lý trí đón nhận những điều Chúa dạy vì chính thế giá của Thiên Chúa.

“Tin vì chính thế giá của Thiên Chúa” nghĩa là:  
Có nhiều điều trí khôn loài người không hiểu được, nhưng ta chấp nhận vì:

- Thiên Chúa là Đấng thông minh → không sai lầm  
- Thiên Chúa là Đấng chân thật → không lừa dối  

Vì thế, tin là:
- Một hoạt động siêu nhiên  
- Một nhân đức  
- Một ơn Chúa ban  

 Kinh Tin tóm tắt những điều chính yếu phải tin và lý do phải tin.

---

###  Đức tin sống động

Nếu việc tin chỉ dừng lại ở lý trí mà không có việc làm thì đó là “đức tin chết” (x. Gc 2,17).

Tin còn là việc của ý chí:
- Quyết tâm sống điều Chúa dạy  
- Phó thác đời sống cho Chúa  
- Gắn bó đời mình với Chúa  

Đó mới là đức tin thật, đem lại ơn cứu độ.

---

##  B. CẬY (Cậy trông)

###  Cậy trông là gì?

Cậy trông là thái độ tâm hồn giúp ta chắc chắn sẽ đạt hạnh phúc đời đời nhờ các phương tiện Chúa ban.

Ta hy vọng chắc chắn vì:
- Chúa yêu thương → muốn điều tốt cho ta  
- Chúa quyền năng → có thể thực hiện điều đã hứa  

Đức cậy là:
- Kết quả của ơn Chúa  
- Một nhân đức siêu nhiên  

 Kinh Cậy tóm tắt những điều ta hy vọng và lý do hy vọng.

---

###  Đức cậy giúp ta sống thế nào?

- Không bám víu quá mức vào của cải, danh vọng đời này  
- Siêng năng sử dụng các phương tiện Chúa ban  
- Nhẫn nại trong thử thách như các thánh  

Đức cậy giúp ta:
- Cậy dựa vào Chúa  
- Nhưng không ỷ lại mà lười biếng làm lành

---

##  C. MẾN

###  Mến là gì?

Mến là thái độ tâm hồn giúp ta:

- Yêu Chúa trên hết mọi sự  
- Yêu thương mọi người vì Chúa muốn như vậy  

“Yêu Chúa hơn mọi sự” nghĩa là:
- Đặt Chúa ở vị trí cao nhất  
- Sẵn sàng hy sinh tất cả vì Chúa  

Đức Mến là:
- Ơn Chúa ban  
- Nhân đức làm ta yêu Chúa và yêu tha nhân  

 Kinh Mến diễn tả lý do và đối tượng của tình yêu ấy.

---

###  Giá trị của Đức Mến

- Bao gồm mọi nhân đức (1 Cr 13,4-7)  
- Quý hơn mọi ân huệ khác (1 Cr 13,1-3)  
- Là nhân đức duy nhất tồn tại đời đời  

Trên Thiên đàng:
- Không còn tin (vì đã thấy)  
- Không còn cậy (vì đã đạt)  
- Chỉ còn tình yêu tồn tại muôn đời  

---

##  D. THỜ PHƯỢNG

###  Thờ phượng là gì?

Thờ phượng là dâng lên Thiên Chúa sự tôn thờ xứng hợp vì:

- Người vô cùng hoàn hảo  
- Người là Đấng Tạo Hóa  

Đây là hành vi thuộc đức công bình.

---

###  Bao gồm nội tâm và bên ngoài

**Tâm tình bên trong:**
- Thờ lạy  
- Cảm tạ  
- Sám hối  
- Cầu xin  

**Hành động bên ngoài:**
- Thánh lễ  
- Bí tích  
- Giờ kinh Phụng vụ  
- Lần hạt, Đàng Thánh Giá  
- Hoạt động tông đồ  

---

###  Chính là cầu nguyện

Cầu nguyện có thể:

- Trong Phụng vụ (Thánh lễ, Bí tích, Giờ kinh)  
- Ngoài Phụng vụ (kinh riêng, lời nguyện cá nhân…)

---

#  III. BÀI HỌC

**41. H. Đức tin là gì?**  
T. Đức tin là nhân đức siêu nhiên giúp ta vững lòng phó thác vào Chúa mà chấp nhận những điều Chúa dạy và nhờ Hội Thánh truyền lại cho ta.

**42. H. Đức cậy là gì?**  
T. Đức cậy là nhân đức siêu nhiên giúp ta trông đợi vững vàng, nhờ công nghiệp Chúa Giêsu, ta sẽ được ơn sống xứng đáng đời này và hưởng phúc đời sau.

**43. H. Đức mến là gì?**  
T. Đức mến là nhân đức siêu nhiên làm cho ta kính mến Thiên Chúa trên hết mọi sự và thương yêu mọi người như Chúa yêu ta.

**44. H. Ta phải thờ phượng Thiên Chúa cách nào?**  
T. Ta phải thờ phượng Thiên Chúa trong lòng và bên ngoài cùng tham dự việc thờ phượng chính thức của Hội Thánh gọi là Phụng vụ.

---

# 🌱 IV. THÁI ĐỘ SỐNG

Tôi chấp nhận mọi điều Chúa dùng Hội Thánh dạy dỗ tôi và quyết sống theo những điều ấy.

---

#  V. CẦU NGUYỆN

Sốt sắng đọc Kinh Tin.
`
},
{
  id: 15,
  title: "Sống hiếu thảo",
  tag: "CHƯƠNG II",
  desc: "Điều răn thứ bốn dạy con người sống hiếu thảo với cha mẹ, ông bà và tổ tiên, đồng thời biết kính trọng và chu toàn bổn phận trong gia đình và xã hội.",
  content: `#  I. LỜI CHÚA

“Kẻ làm con hãy vâng lời cha mẹ, theo tinh thần của Chúa, vì đó là điều phải đạo. ‘Hãy tôn kính cha mẹ’, đó là điều răn thứ nhất có kèm theo lời hứa: ‘Để ngươi được hạnh phúc và hưởng thọ trên mặt đất này.’” (Ep 6,1-3)

---

#  II. TRÌNH BÀY

##  Điều răn thứ bốn dạy ta điều gì?

Điều răn thứ bốn dạy ta sống hiếu thảo với cha mẹ, ông bà, tổ tiên – những người đã sinh thành và dưỡng dục ta.

---

##  Nền tảng của đức hiếu thảo

Nền tảng của đức hiếu thảo là lòng kính sợ Thiên Chúa, Đấng là nguồn gốc mọi tình phụ tử trên trời dưới đất.

Vì thế, trong một số trường hợp, việc vâng lời cha mẹ phải nhường bước cho việc vâng lời Thiên Chúa. Nếu cha mẹ truyền dạy điều trái luật Chúa, người con không được làm theo.

---

##  Con cái sống hiếu thảo như thế nào?

### a) Khi cha mẹ còn sống

Con cái phải:

- Yêu mến cha mẹ vì các ngài đã sinh thành và dưỡng dục ta  
- Tôn kính vì các ngài là bậc cao niên, có kinh nghiệm sống  
- Vâng lời vì các ngài thay mặt Chúa dạy dỗ điều hay lẽ phải  
- Giúp đỡ khi cha mẹ già yếu, đau bệnh, túng thiếu hoặc suy giảm sức khỏe  

---

### b) Khi cha mẹ qua đời

Con cháu phải:

- Lo chôn cất và cầu nguyện cho người đã qua đời  
- Dâng lễ, làm giỗ và tưởng nhớ  

Hội Thánh có nhiều nghi thức như: làm phép xác, thánh lễ an táng, lễ giỗ, tháng các linh hồn… Những nghi thức này diễn tả đức tin vào sự sống đời sau, tôn trọng thân xác và giúp cầu nguyện cho người đã khuất.

Các hình thức hiếu kính theo truyền thống dân gian được khuyến khích, miễn không trái với đức tin Công giáo.

---

##  Bổn phận của cha mẹ đối với con cái

Cha mẹ có trách nhiệm:

- Sinh sản có trách nhiệm  
- Nuôi dưỡng và giáo dục con cái nên người tốt và nên tín hữu  
- Giáo dục bằng gương sáng  
- Kết hợp với nhà trường và giáo xứ trong việc giáo dục con cái  

---

##  Đối với Hội Thánh

Người tín hữu được tái sinh và lớn lên trong Hội Thánh, vì thế phải:

- Yêu mến Hội Thánh  
- Vâng lời Hội Thánh  
- Cộng tác xây dựng và truyền bá đức tin  

---

## 6️⃣ Tình yêu quê hương – dân tộc

Người Công giáo phải:

- Tôn trọng luật pháp chính đáng của quốc gia  
- Tích cực tham gia việc ích quốc lợi dân  
- Kính trọng chính quyền, thầy cô, người lớn tuổi  
- Sống hài hòa giữa đức tin và trách nhiệm công dân  

---

#  III. BÀI HỌC

**45. H. Điều răn thứ bốn dạy ta điều gì?**  
T. Dạy ta sống hiếu thảo với cha mẹ, ông bà, tổ tiên; đồng thời dạy các bổn phận của cha mẹ đối với con cái.

**46. H. Sống hiếu thảo hệ tại điều gì?**  
T. Hệ tại yêu mến, tôn kính, vâng lời và giúp đỡ cha mẹ cùng các bậc trên.

**47. H. Ta còn phải kính nể và vâng lời ai nữa không?**  
T. Ta còn phải kính nể và vâng lời các vị lãnh đạo tôn giáo và xã hội.

---

#  IV. THÁI ĐỘ SỐNG

Dù ở lứa tuổi hay địa vị nào, tôi luôn yêu mến, tôn trọng và biết ơn những người đã sinh thành, dưỡng dục mình.

---

#  V. CẦU NGUYỆN

Lạy Chúa, xin cho con biết sống trọn chữ hiếu đối với ông bà, cha mẹ và tổ tiên, để mai sau được cùng các ngài hưởng phúc trường sinh. Amen.`
},
{
  id: 16,
  title: "Tôn trọng sự sống – Sống trong sạch",
  tag: "CHƯƠNG II",
  desc: "Điều răn 5, 6 và 9 dạy con người biết tôn trọng sự sống, bảo vệ thân xác, tâm hồn và sống đời sống trong sạch theo ý Chúa.",
  content: `#  I. LỜI CHÚA

“Anh em đã nghe luật người xưa dạy rằng: chớ giết người. Ai giết người sẽ bị đưa ra tòa. Còn Thầy, Thầy bảo cho anh em biết: Ai giận anh em mình, thì cũng đáng bị đưa ra tòa rồi.” (Mt 5,21-22)

---

#  II. TRÌNH BÀY

##  Điều răn 5, 6 và 9 dạy ta điều gì?

Dạy ta quý trọng sự sống thể xác, tinh thần và siêu nhiên của mình và của người khác.

---

##  Vì sao phải tôn trọng thân xác và sự sống?

Vì thân xác là kỳ công của Thiên Chúa, là Đền Thờ Chúa Thánh Thần và ngày sau sẽ được sống lại.

Sự sống đời này là ân huệ quý giá nhất trong đời sống tự nhiên. Mất của cải có thể làm lại, nhưng mất sự sống thì không bao giờ lấy lại được.

---

##  Tôn trọng sự sống thể xác

### a) Phải chăm sóc sức khỏe

- Bồi dưỡng sức khỏe, giữ gìn thân thể khỏe mạnh  
- Tránh làm việc quá sức, nghiện ngập, say sưa  

### b) Tránh làm hại sự sống

- Không đánh đập, bắt cóc, bạo lực  
- Không xúi giục hoặc gây hại cho người khác  
- Không lái xe khi say rượu hoặc mất an toàn  
- Không phá hoại môi trường sống  
- Không liều lĩnh gây nguy hiểm khi không cần thiết  

---

##  Tôn trọng sự sống tinh thần và siêu nhiên

### a) Nuôi dưỡng đời sống tốt đẹp

- Sống vị tha, bác ái, nhân hậu, khoan dung  
- Phát triển tài năng, nghề nghiệp  
- Ăn mặc đoan trang, cư xử lịch sự  

### b) Tránh điều xấu trong tâm hồn

- Tránh giận dữ, ghen ghét, oán thù  
- Tránh tư tưởng dâm ô, lời nói thô tục  
- Tránh đọc, xem, lan truyền nội dung xấu  
- Tránh các hành vi vô luân, bất chính  

---

##  Ai phải sống trong sạch?

Mọi người đều được mời gọi sống trong sạch:

### a) Người sống đời tu trì

- Sống độc thân vì Nước Trời  
- Là dấu chỉ về đời sống mai sau nơi Thiên Chúa  

### b) Người sống đời hôn nhân

- Trung thành với nhau  
- Tôn trọng nhau trong đời sống vợ chồng  
- Xây dựng gia đình yêu thương, thanh khiết  

---

## 6️⃣ Phương thế sống trong sạch

- Tham dự các Bí tích, nhất là Giải Tội và Thánh Thể  
- Yêu mến Đức Mẹ Maria  
- Tham gia sinh hoạt tông đồ  
- Sống cầu nguyện và kết hợp với Chúa  

---

#  III. BÀI HỌC

**48. H. Điều răn 5, 6 và 9 dạy ta điều gì?**  
T. Dạy ta quý trọng sự sống thể xác, tinh thần và siêu nhiên của mình và của người khác.

**49. H. Tại sao phải quý trọng sự sống thể xác?**  
T. Vì thân xác là kỳ công của Thiên Chúa, là Đền Thờ Chúa Thánh Thần và sẽ sống lại đời sau.

**50. H. Tại sao phải quý trọng sự sống siêu nhiên?**  
T. Vì “Được lời lãi cả thế gian mà mất linh hồn thì được ích gì?” (Mt 16,26)

---

#  IV. THÁI ĐỘ SỐNG

Tôi quyết chăm sóc sự sống thể xác, tinh thần và siêu nhiên của mình, để xứng đáng với tình yêu Thiên Chúa và đạt tới hạnh phúc đời đời.

---

#  V. CẦU NGUYỆN

Lạy Chúa, xin cho con biết quý trọng sự sống thân xác và linh hồn, để sống đẹp lòng Chúa ở đời này và được hưởng hạnh phúc đời sau. Amen.`
},
{
  id: 17,
  title: "Sống công bình – Sống theo sự thật",
  tag: "CHƯƠNG II",
  desc: "Điều răn 7, 8 và 10 dạy tôn trọng của cải, sự thật và danh giá người khác.",
  content: `
#  I. LỜI CHÚA
“Của Xê-da, trả về Xê-da; của Thiên Chúa, trả về Thiên Chúa.” (Mt 22,21)

#  II. TRÌNH BÀY

## Điều răn thứ 7 và 10 dạy ta những gì?
Dạy ta tôn trọng của cải người khác trong hành động cũng như trong tư tưởng.

---

## 1. Tôn trọng của cải người khác trong hành động là gì?
Là không gây thiệt hại về của cải người khác:
- Gian lận, lường gạt
- Tráo đổi sản phẩm
- Trộm cắp, hối lộ
- Vay mượn không trả
- Làm hư hao không đền bù
- Làm việc thiếu tận tâm
- Không trả tiền lương cân xứng
- Oa trữ của gian
- Không trả của lượm được khi có thể

---

## 2. Tôn trọng của cải người khác trong tư tưởng là gì?
Là chấp nhận quyền sở hữu của người khác đối với tài sản của họ;  
Không tham lam, không mơ ước chiếm đoạt bất công, vì ước muốn bất chính là căn nguyên dẫn đến hành vi sai trái.

---

## 3. Có khi nào ta lỗi điều răn 7 đối với người nghèo không?
Có.

Của cải là tài sản chung cho mọi người.  
Quyền tư hữu là chính đáng, nhưng:
- Hoang phí là có tội  
- Hà tiện là có tội  
- Không chia sẻ khi có thể giúp người nghèo là “giữ của cách bất công”  
- Là xúc phạm đến chính Chúa (x. Mt 25,31-46)

---

## 4. Điều răn 8 dạy ta những gì?
Dạy ta tôn trọng sự thật và danh giá người khác.

---

## 5. Tôn trọng sự thật là gì?
Là:
- Suy nghĩ ngay thẳng  
- Nói đúng sự thật  
- Hành động theo lương tâm đã được giáo dục  

---

## 6. Tại sao phải tôn trọng sự thật?
Vì Chúa Giêsu là Sự Thật.  
Sống theo sự thật là sống theo Chúa Giêsu.

Vì sự thật là nền tảng đời sống xã hội và là căn bản cho giao tiếp giữa con người.

---

## 7. Khi nào ta lỗi sự thành thật?
Khi:
- Ăn gian nói dối  
- Lừa đảo  
- Chữa mình  
- Không đủ can đảm nhận khuyết điểm  

Không bao giờ được phép nói dối, dù để chữa mình hay bênh vực người khác.  
Khi lương tâm đòi giữ kín điều gì, ta phải nói cách khôn ngoan để không tiết lộ.

---

## 8. Tôn trọng danh giá người khác là gì?
“ Tốt danh hơn lành áo ”

Làm hại danh giá người khác là tội nặng:
- Nói hành  
- Vu oan  
- Dị nghị  
- Cắt nghĩa xấu cho người khác  
- Hồ nghi vô căn cứ  

---

## 9. Phải đền bù danh giá người khác cách nào?
Phải:
- Xin lỗi công khai  
- Đính chính với người đã nghe mình vu oan  
- Trả lại danh dự  
- Đền bù thiệt hại vật chất nếu có  

---

#  III. BÀI HỌC

### 51. H. Điều răn thứ 7 và 10 dạy ta những gì?  
T. Dạy ta tôn trọng của cải người khác trong hành động cũng như trong tư tưởng.

### 52. H. Có khi nào ta lỗi điều răn thứ 7 đối với người nghèo không?  
T. Có. Khi ta có thể giúp mà bỏ qua, hoặc hoang phí, hoặc hà tiện.

### 53. H. Điều răn thứ 8 dạy ta những gì?  
T. Dạy ta tôn trọng sự thật và danh giá người khác.

### 54. H. Khi lỗi những điều răn này, ta phải làm gì?  
T. Phải tìm cách đền bù cân xứng.

---

#  IV. THÁI ĐỘ SỐNG
Vi phạm của cải, danh giá người khác thì dễ mà đền bù thì rất khó.  
Tôi quyết tâm không xâm phạm của cải và danh dự bất cứ ai.

---

# 🕊 V. CẦU NGUYỆN
Lạy Chúa, Chúa dạy con tôn trọng của cải và danh dự người khác.  
Xin giúp con biết thực thi công bình và bác ái với mọi người.
`
},
{
  id: 18,
  title: "Tinh thần mới trong luật cũ",
  tag: "CHƯƠNG II",
  desc: "Chúa Giêsu kiện toàn luật cũ bằng tinh thần yêu thương.",
  content: `
#  I. LỜI CHÚA
“Anh em đừng tưởng Thầy đến để bãi bỏ luật Môsê hoặc giáo huấn của các Ngôn sứ. 
Thầy đến không phải để bãi bỏ, nhưng là để kiện toàn. 
Vì, Thầy bảo thật anh em, trước khi trời đất qua đi và cho đến khi mọi sự được hoàn thành, 
thì một chấm một phết trong sách luật cũng không thể bỏ đi được.” (Mt 5,17-18)

---

#  II. TRÌNH BÀY

Mười điều răn là bản đúc kết những điều chính yếu Thiên Chúa truyền cho Israel phải tuân giữ.  
Chúa Giêsu cũng dạy lại những điều ấy, nhưng Người đã thổi vào đó một tinh thần mới làm cho luật trở nên sáng giá hơn.

---

## 1. Thái độ của Chúa Giêsu đối với luật cũ

Chúa Giêsu luôn tôn trọng luật cũ:

- Công nhận giá trị bắt buộc của luật  
- Tuân giữ luật  
- Dạy người khác giữ luật  

Một thanh niên hỏi: “Phải làm gì để được sống đời đời?”  
Chúa đáp: “Chớ giết người, chớ ngoại tình, chớ trộm cắp, chớ làm chứng gian.  
Hãy thảo kính cha mẹ và yêu thương mọi người như chính mình” (Mt 19,16-19).

---

## 2. Cách giữ luật của người xưa

Vào thời Chúa Giêsu, dân Israel giữ luật nhưng nặng về hình thức, nhất là các biệt phái và luật sĩ.

- Giữ luật vì luật  
- Làm cho đời sống trở nên gò bó, nặng nề  
- Coi việc nhỏ như bứt bông lúa, dắt bò đi uống nước ngày Sabát là phạm luật  
- Thêm thắt tục lệ thành luật Chúa  

Chúa phán:
“Dân này chỉ thờ Ta bằng môi miệng, còn lòng chúng thì xa Ta” (Mt 15,8).

Thánh Phaolô nói:
“Chữ viết làm cho chết” (2 Cr 3,6).

Giữ luật theo kiểu hình thức bóp chết tự do của người con Thiên Chúa.

---

## 3. Tinh thần mới trong giới luật cũ

Chúa Giêsu:

- Gạn lọc những thêm thắt của người đời  
- Đưa vào luật một tinh thần mới: **TÌNH YÊU**

Ai giữ luật vì tình yêu thì tình yêu sẽ phát huy nơi người ấy.

“Ách của Ta thì êm ái, gánh của Ta thì nhẹ nhàng” (Mt 11,30).

Tinh thần mới ấy là:

##  Yêu Thiên Chúa  
##  Yêu mọi người  

Vì yêu thương ta, Thiên Chúa ban giới luật để ta sống hạnh phúc.

“Ai yêu mến Thầy thì sẽ giữ lời Thầy” (Ga 14,22).

“Anh em hãy yêu thương nhau như Thầy đã yêu thương anh em” (Ga 13,34).

Yêu Thiên Chúa và yêu mọi người — đó là tinh thần mới Chúa Giêsu phổ vào luật cũ để ta hiểu biết, yêu mến và tuân hành.

---

#  III. BÀI HỌC

### 55. H. Chúa Giêsu có thái độ nào đối với luật cũ?  
T. Chúa Giêsu luôn tôn trọng, tuân giữ và dạy người ta tuân giữ lề luật.

---

### 56. H. Chúa Giêsu kiện toàn lề luật thế nào?  
T. Chúa Giêsu gạn lọc những thêm thắt của người đời, và đem tình yêu vào từng lề luật để dạy loài người rằng: vì yêu thương, Chúa ban lề luật. Vì thế ta phải giữ luật vì lòng yêu mến Chúa và yêu thương mọi người.

---

#  IV. THÁI ĐỘ SỐNG

Luật pháp được đặt ra vì hạnh phúc con người.  
Tôi tự nguyện tuân giữ các giới luật của Chúa và Hội Thánh để được sống đời đời.

---

#  V. CẦU NGUYỆN

Lạy Chúa Giêsu,  
Chúa đã dạy: “Ai giữ và dạy người khác giữ những điều luật nhỏ nhất, sẽ được làm lớn trong Nước Trời.”  

Xin giúp con biết tuân giữ mọi lề luật của Chúa và của Hội Thánh với tinh thần yêu thương.
`
},
{
  id: 19,
  title: "Chúa Giêsu chịu chết và sống lại",
  tag: "CHƯƠNG II",
  desc: "Biến cố Tử nạn – Phục sinh là trung tâm công cuộc cứu độ của Chúa Giêsu.",
  content: `
#  I. LỜI CHÚA
“Này chúng ta lên Giêrusalem và Con Người sẽ bị nộp cho các Thượng tế và Kinh sư. 
Họ sẽ lên án xử tử Người, sẽ nộp Người cho dân ngoại nhạo báng, đánh đòn và đóng đinh vào thập giá, 
và ngày thứ ba, Người sẽ sống lại” (Mt 20,18-19).

---

#  II. TRÌNH BÀY

Chúa Giêsu người Nazareth được Thiên Chúa sai đến để ban sự sống mới cho loài người. 
Người đã làm nhiều phép lạ để chứng minh sứ mệnh của mình. 
Theo kế hoạch Thiên Chúa đã định, Chúa Giêsu đã bị nộp và bị đóng đinh vào thập giá, 
nhưng Thiên Chúa đã làm cho Người sống lại (x. Cv 2,22-23).

---

## 1. Chúa Giêsu ban sự sống mới cho loài người

Chúa Giêsu thực là Đấng Cứu Thế. Người đến để rao truyền đạo lý Nước Trời.

Những ai tin vào Chúa đều được sống:
- Người mù, què, câm, điếc, bệnh tật được chữa lành  
- Nicôđêmô, một nhân vật vị vọng trong dân  
- Lêvi người thu thuế  
- Maria Mađalena tội lỗi  
- Thiếu phụ Samaria  

Tất cả đều được an bình và niềm vui sống nhờ tin nhận Chúa Giêsu.

---

## 2. Nhưng Chúa Giêsu lại bị người đời giết chết

Giáo lý của Chúa có nhiều điều trái với ý nghĩ và thói tục thế gian.

“Lời này chói tai quá, ai nghe nổi” (Ga 6,60).

Chúa vạch trần cách sống giả hình tự mãn của Biệt phái và Luật sĩ. 
Vì thế nhiều kẻ ghét Người, tìm cách bắt bẻ và hãm hại Người. 

Có lần dân chúng xô Chúa khỏi Hội đường, lôi Người lên triền núi định đẩy xuống vực thẳm.

---

## 3. Tuần lễ của hận thù và yêu thương

Khoảng tháng tư năm cuối cùng cuộc đời, Chúa Giêsu lên Giêrusalem mừng lễ Vượt Qua.

- Người được dân chúng tung hô như vua khải hoàn  
- Trong bữa Tiệc Ly, Người lập Bí tích Thánh Thể  
- Người rửa chân cho các môn đệ dạy bài học phục vụ  
- Trong vườn Cây Dầu, Người cầu nguyện trong đau khổ  
- Giuđa phản bội bằng cái hôn  
- Công nghị Do Thái nhờ Philatô kết án Người  

Chúa bị đánh đập, đội mão gai, vác thập giá lên Núi Sọ và bị đóng đinh vào thập giá lúc giữa trưa.  
Người tắt thở lúc 3 giờ chiều.  

Nicôđêmô xin tháo xác và mai táng Người trong mồ đá.

Mọi hy vọng dường như đã tan biến.

---

## 4. Chiến thắng tử thần

Sáng sớm ngày thứ nhất trong tuần, Maria Mađalena và một Maria khác ra viếng mộ.

Thiên thần nói:
“Người không còn ở đây nữa. Người đã sống lại như Người đã báo trước” (Mt 28,1-7).

Sau khi sống lại:
- Chúa hiện ra dạy dỗ, an ủi các môn đệ  
- Sai các ông đi rao giảng Tin Mừng  
- Lên trời ngự bên hữu Chúa Cha  
- Và sẽ trở lại trong vinh quang để phán xét kẻ sống và kẻ chết  

---

## 5. Tuần Thánh hôm nay

Hội Thánh mừng các biến cố này trong Tuần Thánh:

-  Chúa nhật Lễ Lá (Thương Khó)  
- 🍞 Thứ Năm Tuần Thánh (Lập Bí tích Thánh Thể)  
- ✝️ Thứ Sáu Tuần Thánh (Chúa chịu chết)  
- 🕯 Thứ Bảy Tuần Thánh (Chúa an nghỉ trong mồ)  
- 🌅 Chúa nhật Phục Sinh (Chúa sống lại)  

Biến cố Tử nạn – Phục sinh là trung tâm công cuộc cứu độ và là mầu nhiệm trung tâm đời sống Kitô hữu:

“Ai muốn sống lại với Chúa, cũng phải thông phần khổ nạn với Người” (2 Tm 2,11).

---

#  III. BÀI HỌC

### 57. H. Chúa Giêsu đã làm gì để cứu chuộc loài người?  
T. Chúa Giêsu đã tự hiến đời mình, chịu đau khổ, chịu chết trên thập giá và sống lại để cứu chuộc loài người.

---

### 58. H. Sau khi sống lại, Chúa Giêsu làm gì?  
T. Sau khi sống lại, Chúa Giêsu còn hiện ra dạy dỗ, an ủi các môn đệ, sai các ông đi rao giảng Tin Mừng rồi Người lên trời.

---

#  IV. THÁI ĐỘ SỐNG

Vì yêu thương, Chúa Giêsu đã tự nguyện hiến mạng sống để cứu chuộc loài người.  
Tôi quyết chấp nhận những gian khổ trên đường theo Chúa.

---

#  V. CẦU NGUYỆN

Lạy Chúa,  
Trước khi từ bỏ thế gian, Chúa đã thực hiện những công việc đầy tình yêu thương để cứu chuộc loài người.  

Xin giúp con sớm trở thành người con Chúa, để con được hưởng ơn cứu độ và biết đáp lại tình yêu thương cảm động ấy.
`
},
{
  id: 20,
  title: "Chúa Giêsu ban Chúa Thánh Thần cho Hội Thánh",
  tag: "CHƯƠNG II",
  desc: "Chúa Giêsu thực hiện lời hứa, ban Chúa Thánh Thần để thánh hóa và hướng dẫn Hội Thánh.",
  content: `
#  I. LỜI CHÚA

“Thầy sẽ xin Chúa Cha, và Người sẽ ban cho anh em một Đấng Bào Chữa khác đến ở với anh em luôn mãi.” (Ga 14,16)

---

#  II. TRÌNH BÀY

## 1. Chúa Giêsu hứa ban Chúa Thánh Thần

Khi sống với các tông đồ, Chúa Giêsu nhiều lần nói về Chúa Thánh Thần:

- “Không ai có thể vào Nước Thiên Chúa, nếu không sinh ra bởi nước và Thần Khí.  
  Cái gì bởi xác thịt sinh ra thì là xác thịt, còn cái gì bởi Thần Khí mà sinh ra thì là Thần Khí” (Ga 3,5-6).

- Khi thấy các tông đồ buồn sầu vì Chúa sắp ra đi, Chúa an ủi và hứa:  
  “Đấng Bào Chữa là Thánh Thần, Chúa Cha sẽ phái đến nhân danh Thầy.  
  Đấng đó sẽ dạy anh em mọi điều và sẽ làm cho anh em nhớ lại mọi điều Thầy đã nói với anh em” (Ga 14,26).

- Sau Phục sinh, Chúa Giêsu nhắc lại lời hứa:  
  “Phần Thầy, Thầy sẽ gửi cho anh em điều Chúa Cha đã hứa.  
  Vậy anh em hãy ở lại trong thành cho đến khi nhận được quyền năng từ trên ban xuống” (Lc 24,49).

---

## 2. Chúa Giêsu ban Chúa Thánh Thần

- Vào buổi chiều ngày Phục sinh, Chúa Giêsu hiện ra với các tông đồ đang tụ họp nơi phòng Tiệc Ly,  
  thổi hơi ban Chúa Thánh Thần cho các ông và nói:  
  “Anh em hãy nhận lấy Thánh Thần” (Ga 20,22).

- 50 ngày sau, vào lễ Ngũ Tuần, Chúa Giêsu đổ tràn đầy Thánh Thần cách long trọng trên các tông đồ (x. Cv 2,1-4).  

Chúa Thánh Thần đã biến đổi các ông:
- Từ sợ hãi thành can đảm  
- Từ đóng kín cửa thành mạnh dạn ra đi  
- Từ yếu đuối thành chứng nhân hăng say  

Từ ngày đó, Chúa Thánh Thần thánh hóa và hướng dẫn Hội Thánh.

---

#  III. BÀI HỌC

### 59. H. Chúa Giêsu hứa ban Chúa Thánh Thần cho Hội Thánh thế nào?  
T. Chúa Giêsu hứa rằng: “Thầy sẽ xin Chúa Cha, và Người sẽ ban cho anh em một Đấng Bào Chữa khác đến ở với anh em luôn mãi” (Ga 14,16).

---

### 60. H. Chúa Giêsu thực hiện lời hứa ra sao?  
T. Sau khi sống lại, Chúa Giêsu đã sai Chúa Thánh Thần đến với các tông đồ.  
Chính Chúa Thánh Thần biến đổi các ông thành những người mạnh dạn rao giảng Đức Kitô Phục sinh cho thế giới.

---

#  IV. THÁI ĐỘ SỐNG

Chúa Thánh Thần biến đổi các tông đồ thành những người can đảm.  
Tôi siêng năng cầu nguyện với Chúa Thánh Thần, xin Người ban cho tôi ơn can đảm để tuân giữ luật Chúa.

---

#  V. CẦU NGUYỆN

Lạy Chúa Thánh Thần,  
Xin ngự đến soi sáng trí lòng con,  
đốt lửa yêu mến trong tâm hồn con,  
giúp con sống xứng đáng là con cái Chúa  
và trở nên chứng nhân can đảm cho Tin Mừng.  
Amen.
`
},
{
  id: 21,
  title: "Chúa Thánh Thần - Hồn sống của Hội Thánh",
  tag: "CHƯƠNG II",
  desc: "Chúa Thánh Thần làm cho Hội Thánh sống động, hiệp nhất, thánh hóa và hướng dẫn mọi thành phần Dân Chúa.",
  content: `
#  I. LỜI CHÚA

“Đấng Bảo Trợ là Thánh Thần Chúa Cha sẽ sai đến nhân danh Thầy, Đấng đó sẽ dạy anh em mọi điều và sẽ làm cho anh em nhớ lại mọi điều Thầy đã nói với anh em.” (Ga 14,26)

---

#  II. TRÌNH BÀY

Ví như linh hồn làm cho thân xác sống động và phối trí mọi sinh hoạt nơi con người,  
Chúa Thánh Thần cũng làm cho Hội Thánh sống động và điều hành mọi sinh hoạt trong Hội Thánh.  

Vì thế, ta xưng tụng Chúa Thánh Thần là **Hồn sống của Hội Thánh**.

---

## 1. Chúa Thánh Thần làm gì cho các tông đồ?

- Chúa Thánh Thần nhắc lại và giúp các tông đồ hiểu rõ hơn những điều Chúa Giêsu dạy khi còn tại thế, nhất là về thân thế và sự nghiệp của Người, về cái chết ô nhục trên thập giá và sự sống lại vinh quang (x. Ga 14,26).

- Chúa Thánh Thần làm cho các tông đồ được mạnh mẽ trong đức tin, can đảm rao giảng Chúa Kitô chịu đóng đinh và sống lại, bất chấp mọi cấm cản, cực hình và nguy hiểm đe dọa tính mạng.

---

## 2. Chúa Thánh Thần làm gì cho Hội Thánh?

- Chúa Thánh Thần thánh hóa, canh tân và hiệp nhất mọi thành phần trong Hội Thánh:  
  “Tất cả chúng ta, dầu là Do Thái hay Hy Lạp, nô lệ hay tự do, chúng ta đều đã chịu phép rửa trong cùng một Thần Khí để trở nên một thân thể. Tất cả chúng ta đã được đầy tràn một Thần Khí duy nhất” (1 Cr 12,13).

- Chúa Thánh Thần khơi động và hỗ trợ mọi hoạt động của Hội Thánh (x. Cv 11,15).

- Chúa Thánh Thần làm cho thửa vườn Hội Thánh trổ sinh nhiều hoa trái:  
  “Hoa quả của Thần Khí là: bác ái, hoan lạc, bình an, nhẫn nhục, nhân hậu, từ tâm, trung tín, hiền hòa, tiết độ” (Gl 5,22-23).

- Đồng thời, Chúa Thánh Thần cũng ban nhiều đặc sủng khác nhau như:  
  ơn khôn ngoan, ơn nói tiên tri, ơn làm phép lạ… để phục vụ Hội Thánh (x. 1 Cr 12,1-11).

- Đối với mỗi tín hữu, Chúa Thánh Thần thánh hóa và làm cho họ trở nên chứng nhân của Chúa Kitô (x. Ga 15,26).

Vậy:  
“Nếu chúng ta sống nhờ Thần Khí, thì cũng hãy nhờ Thần Khí mà tiến bước” (Gl 5,25),  
vì Thần Khí ban sự sống (x. 1 Cr 3,6).

---

#  III. BÀI HỌC

### H. Tại sao Chúa Thánh Thần là hồn sống của Hội Thánh?  
T. Vì Chúa Thánh Thần làm cho Hội Thánh sống động và điều hành mọi sinh hoạt trong Hội Thánh.

---

### H. Chúa Thánh Thần làm gì cho Hội Thánh?  
T. Chúa Thánh Thần hằng gìn giữ, hướng dẫn, thánh hóa và canh tân Hội Thánh ở thế gian này.

---

### H. Chúa Thánh Thần làm gì cho người tín hữu?  
T. Chúa Thánh Thần thánh hóa và làm cho người tín hữu trở nên chứng nhân của Chúa Kitô.

---

#  IV. THÁI ĐỘ SỐNG

Chúa Thánh Thần là Thầy dạy Chân lý và là nguồn sức mạnh.  
Tôi luôn tuân theo ơn soi sáng của Người.

---

#  V. CẦU NGUYỆN

Lạy Chúa Thánh Thần, xin Người ngự đến.  
Và từ trời tỏa ánh vinh quang của Người ra.  

Xin uốn nắn điều cứng cỏi,  
Sưởi ấm chốn lạnh lùng,  
Chỉnh đốn lại chỗ trật đường.  

Xin ban cho các tín hữu,  
Là những người tin cậy Chúa,  
Được ơn bảy nguồn.  
Amen.
`
},
{
  id: 22,
  title: "Mầu nhiệm Hội Thánh",
  tag: "CHƯƠNG II",
  desc: "Hội Thánh do Chúa Giêsu thiết lập, vừa hữu hình vừa thiêng liêng, bắt nguồn từ Chúa Ba Ngôi và mang sứ mạng cứu độ.",
  content: `
# I. LỜI CHÚA

“Đức Kitô yêu thương Hội Thánh và hiến mình vì Hội Thánh; như vậy, Người thánh hóa và thanh tẩy Hội Thánh bằng nước và lời hằng sống, để trước mặt Người, có một Hội Thánh xinh đẹp lộng lẫy, không tỳ ố, không vết nhăn hoặc bất cứ một khuyết điểm nào, nhưng thánh thiện và tinh tuyền.” (Ep 5,25-27)

---

# II. TRÌNH BÀY

## 1. Chúa Giêsu thành lập Hội Thánh

Hội Thánh được thành lập qua nhiều giai đoạn.

Trước hết, Thiên Chúa chọn dân Ítraen làm dân riêng để gìn giữ lời hứa cứu độ. Nhưng dân này đã không luôn trung thành với đường lối của Thiên Chúa.

Tuy nhiên, trong Ítraen vẫn còn một số người trung thành. Khi bắt đầu rao giảng Tin Mừng, Chúa Giêsu đã kêu gọi họ để thiết lập một Ítraen mới là Hội Thánh. Trước tiên là Nhóm Mười Hai Tông đồ và những người thành tâm tin theo Người.

Chúa Giêsu huấn luyện các Tông đồ, cho họ sống chung với Người, rồi đặt Phêrô làm đầu. Chính cộng đoàn này là hạt nhân làm phát triển Hội Thánh cho đến tận cùng trái đất.

---

## 2. Hội Thánh là một mầu nhiệm

Gọi Hội Thánh là mầu nhiệm vì cùng với tổ chức hữu hình bên ngoài, Hội Thánh còn có sức sống bên trong, bắt nguồn từ Chúa Ba Ngôi và được thông ban cho mọi tín hữu để sinh nhiều hoa trái.

Xét bề ngoài, Hội Thánh gồm những con người cụ thể (hàng giáo sĩ và giáo dân), có luật lệ hướng dẫn và có những sinh hoạt cụ thể như một tổ chức xã hội.

Nhưng xét bên trong, Hội Thánh có nguồn gốc từ chính Chúa Ba Ngôi. Hội Thánh được nuôi dưỡng bằng các phương tiện siêu nhiên như Lời Chúa và các Bí tích, giúp người tín hữu đạt tới mục đích siêu nhiên là hạnh phúc Nước Trời.

Những yếu tố nội tại này làm cho Hội Thánh không chỉ là một tổ chức trần gian, nhưng trước hết là một tổ chức thiêng liêng.

---

## 3. Các hình ảnh diễn tả Hội Thánh

Công đồng Vaticanô II đã dùng nhiều hình ảnh trong Thánh Kinh để diễn tả Hội Thánh, chẳng hạn:

- Hội Thánh là đàn chiên  
- Hội Thánh là vườn nho  
- Hội Thánh là cánh đồng lúa  
- Hội Thánh là Đền thờ  
- Hội Thánh là hiền thê của Chúa Kitô  

Những hình ảnh này giúp ta hiểu sâu hơn về bản chất và sứ mạng của Hội Thánh.

---

# III. BÀI HỌC

Hỏi: Hội Thánh được thành lập thế nào?  
Trả lời: Khởi đầu, Chúa Giêsu chọn 12 Tông đồ, huấn luyện họ rồi đặt Phêrô làm đầu. Chính cộng đoàn này là hạt nhân làm phát triển Hội Thánh.

Hỏi: Tại sao gọi Hội Thánh là mầu nhiệm?  
Trả lời: Gọi Hội Thánh là mầu nhiệm vì cùng với tổ chức bên ngoài, Hội Thánh còn có sức sống bên trong, bắt nguồn từ Chúa Ba Ngôi và chuyển thông cho mọi tín hữu để phát sinh nhiều hoa trái.

Hỏi: Hãy kể ra một số hình ảnh trong Thánh Kinh diễn tả Hội Thánh?  
Trả lời: Đàn chiên, vườn nho, cánh đồng lúa, Đền thờ, hiền thê của Chúa Kitô.

---

# IV. THÁI ĐỘ SỐNG

Thiên Chúa đã thiết lập Hội Thánh để ban ơn cứu độ cho loài người.  
Tôi muốn thuộc trọn về Hội Thánh và sống hiệp thông với Hội Thánh.

---

# V. CẦU NGUYỆN

Lạy Chúa, con tin rằng ngày con được Rửa tội là ngày con chính thức được nhận vào Hội Thánh.  
Xin cho con được sớm lãnh nhận Bí tích Rửa tội và được sống mãi trong Hội Thánh.  
Amen.
`
},
{
  id: 23,
  title: "Các đặc tính của Hội Thánh Công Giáo",
  tag: "CHƯƠNG I",
  desc: "Hội Thánh có bốn đặc tính: duy nhất, thánh thiện, Công giáo và tông truyền.",
  content: `# I. LỜI CHÚA

“Lạy Cha, xin cho họ được hoàn toàn nên một; như vậy, thế gian sẽ nhận biết là chính Cha đã sai Con và đã yêu thương họ như đã yêu thương Con” (Ga 17,23).

# II. TRÌNH BÀY

Ngay từ những thế kỷ đầu, các tín hữu đã tuyên xưng Hội Thánh có những đặc tính: duy nhất, thánh thiện, Công giáo và tông truyền.

## 1. Hội Thánh duy nhất

### a. Duy nhất nghĩa là chỉ có một

- Chúa Giêsu chỉ thiết lập MỘT Hội Thánh trên nền tảng Phêrô và các Tông đồ (x. Mt 16,16).
- Những người gia nhập Hội Thánh chỉ tuyên xưng một Đức tin, cùng chung việc phụng thờ Thiên Chúa, cùng hiệp nhất với nhau trong tình huynh đệ gia đình con cái Thiên Chúa (x. Ep 4,5).

### b. Sống đặc tính duy nhất

Người tín hữu có nghĩa vụ tăng cường tinh thần hiệp nhất trong Hội Thánh:
- Sống phù hợp với giáo lý của Hội Thánh.
- Đồng tâm nhất trí tham gia các sinh hoạt trong Giáo phận, Giáo xứ.
- Cầu nguyện và sống hiệp nhất.

## 2. Hội Thánh thánh thiện

Thiên Chúa là Đấng thánh. Ai liên kết với Thiên Chúa thì được thông phần sự thánh thiện của Người. Hội Thánh là thánh vì Hội Thánh hằng liên kết với Chúa Kitô.

### a. Một số điểm chứng tỏ Hội Thánh là thánh

- Chúa Kitô, Đấng sáng lập Hội Thánh là nguồn mạch sự thánh thiện.
- Đạo lý của Hội Thánh là đạo lý của Chúa Kitô.
- Hội Thánh hằng được Chúa Thánh Thần gìn giữ, thánh hóa.
- Hội Thánh hằng sử dụng các phương tiện Chúa ban, nhất là các Bí tích để giúp tín hữu nên thánh.
- Hội Thánh hằng trổ sinh hoa trái thánh thiện.

### b. Hội Thánh luôn phải thanh tẩy

Trong thực tế, Hội Thánh chưa đạt được mức thánh thiện trọn vẹn vì còn nhiều phần tử tội lỗi trong Hội Thánh. Vì thế, Hội Thánh luôn phải thanh tẩy như Công đồng Vaticanô II dạy: “Hội Thánh, vì ôm ấp những kẻ có tội trong lòng, nên vừa thánh thiện vừa luôn phải thanh tẩy mình” (Hc. HT 8).

### c. Gương các thánh

Để khích lệ các tín hữu nỗ lực sống thánh, Hội Thánh đã tuyên dương các phần tử ưu tú, nhất là đã giới thiệu Đức Maria như gương mẫu thánh thiện tuyệt hảo cho mọi người noi theo.

## 3. Hội Thánh Công giáo

Công giáo là đạo chung, đạo đón nhận mọi người.

### a. Trong Tin Mừng

- “Anh em hãy đi và làm cho muôn dân trở thành môn đệ, làm phép rửa cho họ nhân danh Chúa Cha, Chúa Con và Chúa Thánh Thần” (Mt 28,19): Chúa mời gọi mọi người, mọi thời đại gia nhập Hội Thánh.
- “Tôi còn có những chiên khác không thuộc ràn này. Tôi cũng phải đưa chúng về” (Ga 10,16): mọi người được mời gọi vào Hội Thánh.
- Chúa khen ngợi lòng tin của viên đại đội trưởng ngoại giáo (x. Mt 8,10); gặp gỡ phụ nữ xứ Samari bên bờ giếng Giacóp (x. Ga 4,5-42); vượt biển sang vùng đất dân ngoại (x. Mt 4,12)... Chúa muốn mọi dân tộc cũng vào Hội Thánh, chứ không phải chỉ có dân Ítraen.

### b. Hoạt động truyền giáo

Hội Thánh hằng hoạt động truyền giáo, luôn đón nhận tất cả mọi người thuộc mọi quốc gia, dân tộc và tầng lớp. Hội Thánh tôn trọng văn hóa của họ, đón nhận mọi truyền thống tốt đẹp miễn là không trái với đức tin.

## 4. Hội Thánh tông truyền

Tông truyền là do các tông đồ truyền lại.

### a. Chúa Giêsu sai các tông đồ

Chúa Giêsu quy tụ các tông đồ, dạy dỗ họ rồi sai đi giảng đạo muôn nơi, làm chứng về sự chết và sự sống lại của Người.

### b. Truyền lại Đức tin

Nhờ Chúa Thánh Thần trợ giúp, Đức tin và giáo lý các tông đồ được truyền lại trọn vẹn cho chúng ta.

### c. Thể hiện trong sinh hoạt Hội Thánh

- Các Đức Giáo Hoàng liên tục kế vị thánh Phêrô, thi hành nhiệm vụ Chủ chăn trên toàn thể Hội Thánh.
- Các Đức Giám Mục kế vị các tông đồ, liên kết với nhau và với Đức Giáo Hoàng làm thành Giám Mục đoàn.
- Nhờ nghi thức đặt tay mà chức Tư Tế phẩm trật từ thời các tông đồ được trao cho một số người để phục vụ dân Chúa.

# III. BÀI HỌC

**Hỏi:** Hội Thánh Chúa Kitô có mấy đặc tính?  
**Trả lời:** Hội Thánh có 4 đặc tính là duy nhất, thánh thiện, Công giáo và tông truyền.

**Hỏi:** Vì sao ta biết Hội Thánh là duy nhất?  
**Trả lời:** Vì Chúa Kitô chỉ thiết lập một Hội Thánh; các tín hữu tuyên xưng một đức tin, cùng tham dự việc thờ phượng Thiên Chúa, cùng hiệp nhất với nhau và tuân phục Đức Giáo Hoàng.

**Hỏi:** Vì sao ta biết Hội Thánh là thánh thiện?  
**Trả lời:** Vì Hội Thánh có Chúa Kitô là đầu, có Chúa Thánh Thần gìn giữ và thánh hóa, có các phương tiện nên thánh và có các hoa trái thánh thiện.

**Hỏi:** Vì sao ta biết Hội Thánh là Công giáo?  
**Trả lời:** Vì Hội Thánh nhận mọi người ở mọi thời đại. Ai thiện tâm đều có thể gia nhập đạo Công giáo.

**Hỏi:** Vì sao ta biết Hội Thánh là tông truyền?  
**Trả lời:** Vì giáo lý đức tin và phẩm trật của Hội Thánh là do các tông đồ truyền lại.

# IV. THÁI ĐỘ SỐNG

Tôi luôn tin và sống những điều Hội Thánh dạy để xứng đáng là thành phần của Hội Thánh duy nhất, thánh thiện, Công giáo và tông truyền.

# V. CẦU NGUYỆN

Lạy Chúa là nguồn sự thánh thiện, con xin đặt cả cuộc đời con dưới sự hướng dẫn của Hội Thánh để được kết hợp với Chúa mà nên thánh.`
},
{
  id: 24,
  title: "Các chức vụ của Hội Thánh",
  tag: "CHƯƠNG I",
  desc: "Hội Thánh tham dự ba chức vụ của Chúa Kitô: Ngôn sứ, Tư tế và Vương giả.",
  content: `# I. LỜI CHÚA

“Anh em là giống nòi được tuyển chọn, là hàng tư tế vương giả, là dân thánh, dân riêng của Thiên Chúa, để loan truyền những kỳ công của Người, Đấng đã gọi anh em ra khỏi miền u tối, vào nơi đầy ánh sáng diệu huyền” (1 Pr 2,9).

# II. TRÌNH BÀY

Khi xuống thế làm người, Chúa Giêsu được xức dầu để trở thành Ngôn sứ, Tư tế và Vương giả (x. Is 42,13). Với ba chức vụ này, Người đã chu toàn sứ mệnh cứu độ do Chúa Cha trao phó.

Khi thiết lập Hội Thánh, Chúa Giêsu thông truyền ba chức vụ ấy cho Hội Thánh.

## 1. Chức vụ Ngôn sứ

Ngôn sứ là người được sai đi nói lời Thiên Chúa.

Chúa Kitô là vị đại Ngôn sứ của Chúa Cha. Người được sai đến trần gian, dùng lời nói và đời sống để loan báo Tin Mừng Nước Thiên Chúa (x. Hc HT 35).

Chúa Kitô thông chia chức vụ ấy cho Hội Thánh và ban Chúa Thánh Thần để Hội Thánh tiếp tục nói lời Thiên Chúa.

Người tín hữu tham dự chức ngôn sứ của Chúa Kitô khi lãnh nhận Bí tích Rửa tội, Thêm sức và thi hành chức vụ này bằng:

a. Bằng lời nói: mạnh dạn phổ biến đạo lý cho người khác.

b. Bằng cuộc sống: luôn sống điều mình tin, can đảm tỏ mình là người có đạo. Nói bằng chính đời sống là cách thi hành chức vụ ngôn sứ hiệu quả nhất.

## 2. Chức vụ Tư tế

Tư tế là người dâng của lễ lên Thiên Chúa.

Chúa Giêsu là Linh mục thượng phẩm. Người thi hành chức vụ này khi dâng chính mình trên thập giá.

Chúa Giêsu thông chia chức vụ Tư tế của Người cho Hội Thánh để Hội Thánh trở thành dân Tư tế, dâng của lễ đẹp lòng Chúa Cha.

Có hai hình thức tham dự chức vụ Tư tế:

a. Tư tế phẩm trật: được ban cho một số tín hữu qua Bí tích Truyền chức để họ thánh hóa, giáo huấn và cai quản dân Chúa.

b. Tư tế phổ quát: được ban cho mọi người đã lãnh nhận Bí tích Rửa tội. Họ được thánh hiến trở thành đền thờ Chúa Thánh Thần và dâng mình làm lễ vật sống động, thánh thiện, đẹp lòng Thiên Chúa (x. Rm 12).

Người giáo dân thi hành chức Tư tế phổ quát khi cộng tác dâng Thánh lễ, lãnh nhận các Bí tích, cầu nguyện, tạ ơn; khi sống chứng tá thánh thiện và thực hành bác ái (x. Hc HT 10).

## 3. Chức vụ Vương giả

Vương giả nghĩa là cai trị trong tinh thần phục vụ.

Chúa Giêsu là Vua khi vâng lời Chúa Cha chịu chết trên thập giá. Nhờ sự vâng phục ấy, Người được tôn vinh trên muôn loài (x. Pl 2,9; 1 Cr 15,24).

Chúa Giêsu thông chia chức vương giả của Người cho Hội Thánh để Hội Thánh cùng thống trị với Người theo tinh thần phục vụ khiêm hạ.

Người tín hữu tham dự chức Vương giả khi lãnh nhận Bí tích Rửa tội và Thêm sức, và thi hành bằng cách:

a. Thống trị các nết xấu nơi bản thân.

b. Làm cho môi trường sống chung quanh trở nên lành mạnh.

c. Phục vụ anh chị em trong tinh thần khiêm hạ và vô vị lợi.

d. Làm cho mọi công việc trần thế thấm nhuần tinh thần Chúa Kitô.

# III. BÀI HỌC

**Hỏi:** Chúa Kitô trao cho Hội Thánh những chức vụ nào?  
**Trả lời:** Chúa Kitô trao cho Hội Thánh ba chức vụ là Ngôn sứ, Tư tế và Vương giả.

**Hỏi:** Chức vụ Ngôn sứ là gì?  
**Trả lời:** Là chức vụ rao giảng, nghĩa là Hội Thánh có nhiệm vụ rao truyền Lời Thiên Chúa cho mọi người.

**Hỏi:** Chức vụ Tư tế là gì?  
**Trả lời:** Là chức vụ thờ phượng, nghĩa là Hội Thánh có nhiệm vụ dâng lên Thiên Chúa lời ca ngợi và lễ vật lòng thành.

**Hỏi:** Chức vụ Vương giả là gì?  
**Trả lời:** Là chức vụ thống trị trong tinh thần phục vụ, nghĩa là Hội Thánh có nhiệm vụ làm cho mọi công việc trần thế thấm nhuần tinh thần Chúa Kitô.

# IV. THÁI ĐỘ SỐNG

Khi gia nhập Hội Thánh, tôi được tham dự ba chức vụ là Ngôn sứ, Tư tế và Vương giả của Chúa Kitô. Tôi cố gắng học biết cách tôn thờ Chúa và phục vụ mọi người.

# V. CẦU NGUYỆN

Lạy Chúa, con sắp được sống trong tập thể Hội Thánh. Xin cho con sẵn sàng làm những điều hữu ích để liên đới trách nhiệm với Hội Thánh.`
},
{
  id: 25,
  title: "Đức Maria trong Mầu nhiệm Hội Thánh",
  tag: "CHƯƠNG I",
  desc: "Đức Maria là thành phần trổi vượt của Hội Thánh, là Mẹ và là mẫu gương cho mọi tín hữu.",
  content: `# I. LỜI CHÚA

“Đứng gần thập giá Đức Giêsu, có thân mẫu Người... Khi thấy thân mẫu và môn đệ mình thương mến đứng bên cạnh, Đức Giêsu nói với thân mẫu rằng: ‘Thưa Bà, đây là con của Bà.’ Rồi Người nói với môn đệ: ‘Đây là mẹ của anh.’ Kể từ giờ đó, người môn đệ rước bà về nhà mình” (Ga 19,25-27).

# II. TRÌNH BÀY

Thiên Chúa muốn cứu chuộc loài người qua con đường nhập thể. Theo kế hoạch ấy, Ngôi Hai phải sinh bởi một người nữ. Đức Maria được chọn làm người nữ đó.

## 1. Đức Maria được cứu độ

Mọi người được cứu độ nhờ công nghiệp của Chúa Giêsu. Đức Maria cũng được cứu độ, nhưng theo cách thế đặc biệt: trong khi mọi người mắc tội nguyên tổ rồi mới được tha, thì Đức Maria được Thiên Chúa gìn giữ khỏi vướng tội ấy ngay từ đầu. Đó là đặc ân Vô nhiễm nguyên tội.

## 2. Đức Maria tham gia vào việc cứu độ của Chúa Giêsu

Đức Maria đã cộng tác vào công trình cứu độ bằng nhiều cách:

- Đón nhận ý Chúa trong biến cố Truyền tin (x. Lc 1,26-38).
- Cưu mang, sinh hạ, nuôi dưỡng và dạy dỗ Chúa Giêsu (x. Lc 1,42; 2,5-7.40.51-52).
- Lắng nghe và thi hành Lời Chúa (x. Lc 2,51).
- Hiệp thông với những đau khổ của Con mình dưới chân thập giá (x. Ga 19,25).

## 3. Đức Maria là thành phần trổi vượt của Hội Thánh

Mẹ là Đấng đầy ơn phúc nhưng vẫn thuộc dòng dõi loài người và liên kết với tất cả những ai cần được cứu độ (x. Hc HT 53). Vì thế, Mẹ là thành phần của Hội Thánh.

Mẹ là thành phần trổi vượt vì:

a. Sứ mệnh cao trọng: được chọn làm Mẹ Đấng Cứu Thế, Đấng sáng lập và là đầu Hội Thánh.

b. Các nhân đức cao vời: đức tin mạnh mẽ, đức cậy vững vàng, đức mến nồng nàn. Mẹ được tuyên xưng là Nữ vương các thánh Tông đồ, Nữ vương các thánh Tử đạo, Nữ vương các thánh Đồng trinh...

## 4. Đức Maria là Mẹ và là mẫu gương cho các tín hữu

Đức Maria đã cộng tác tích cực vào công trình cứu độ để tái lập sự sống siêu nhiên cho các linh hồn. Vì thế, trên bình diện ân sủng, Mẹ thật là Mẹ chúng ta (x. Hc HT 61).

Dù cao trọng, đời sống Mẹ vẫn rất gần gũi:

a. Mẹ gặp nhiều thử thách trong đức tin nhưng vẫn trung thành với Chúa.

b. Mẹ gặp nhiều khó khăn trong đời sống, nhưng gia đình Nadarét vẫn đầy yêu thương và cần cù lao động.

Chúng ta cũng gặp thử thách phần hồn và phần xác. Hãy nhìn lên Mẹ để được nâng đỡ, được cầu bầu và sống kiên vững.

Ta noi theo Mẹ bằng cách:
- Vâng theo ý Chúa.
- Sống khiêm hạ phục vụ.
- Suy gẫm Lời Chúa.
- Cầu nguyện với Hội Thánh và cho Hội Thánh.
- Siêng năng lần hạt Mân Côi và sốt sắng mừng lễ Mẹ.

# III. BÀI HỌC

**Hỏi:** Đức Maria có cần được cứu độ không?  
**Trả lời:** Đức Maria cũng cần được cứu độ như mọi người; nhưng Mẹ được cứu độ theo cách đặc biệt: được gìn giữ khỏi tội nguyên tổ. Đó là đặc ân Vô nhiễm nguyên tội.

**Hỏi:** Đức Maria đã cộng tác vào công việc cứu độ của Chúa Giêsu như thế nào?  
**Trả lời:** Mẹ đã đón nhận ý định cứu độ của Thiên Chúa, cưu mang và sinh hạ Chúa Giêsu, nhất là đã hiệp thông đau khổ với Con mình dưới chân thập giá.

**Hỏi:** Đức Maria có phải là thành phần của Hội Thánh không?  
**Trả lời:** Đức Maria là thành phần của Hội Thánh vì Mẹ cũng được cứu độ nhờ công nghiệp Chúa Giêsu. Hơn nữa, Mẹ là thành phần trổi vượt vì sứ mệnh cao trọng và các nhân đức tuyệt hảo của Mẹ.

**Hỏi:** Ta phải làm gì để tôn kính và yêu mến Mẹ Maria?  
**Trả lời:** Ta phải noi theo đức tin, đức cậy, đức mến của Mẹ; vâng theo ý Chúa, sống khiêm hạ phục vụ, suy gẫm Lời Chúa; siêng năng lần hạt Mân Côi và sốt sắng mừng lễ Mẹ.

# IV. THÁI ĐỘ SỐNG

Đức Maria là thành phần trổi vượt trong Hội Thánh và là Mẹ tôi. Tôi đến với Mẹ để xin Mẹ giúp tôi sống xứng đáng làm con cái Hội Thánh.

# V. CẦU NGUYỆN

Sốt sắng đọc kinh Kính Mừng:

Kính mừng Maria đầy ơn phúc, Đức Chúa Trời ở cùng Bà,  
Bà có phúc lạ hơn mọi người nữ,  
và Giêsu con lòng Bà gồm phúc lạ.

Thánh Maria Đức Mẹ Chúa Trời,  
cầu cho chúng con là kẻ có tội,  
khi nay và trong giờ lâm tử. Amen.`
},
{
  id: 26,
  title: "Năm Phụng vụ",
  tag: "CHƯƠNG I",
  desc: "Năm Phụng vụ là chu kỳ một năm trong đó Hội Thánh cử hành các mầu nhiệm cứu độ của Chúa Kitô.",
  content: `# I. LỜI CHÚA

“Nếu miệng bạn tuyên xưng Đức Giêsu là Chúa, và lòng bạn tin rằng Thiên Chúa đã làm cho Người sống lại từ cõi chết, thì bạn sẽ được cứu độ. Quả thế, có tin thật trong lòng, mới được nên công chính; có xưng ra ngoài miệng, mới được ơn cứu độ” (Rm 10,9-10).

# II. TRÌNH BÀY

Hội Thánh phô diễn mầu nhiệm Chúa Kitô qua thời gian một năm: từ Nhập thể, Giáng sinh đến Phục sinh, Thăng thiên, Hiện xuống, sự mong đợi hồng phúc và ngày Chúa lại đến. Hội Thánh cử hành toàn bộ công trình cứu độ ấy qua chu kỳ một năm gọi là Năm Phụng vụ.

## 1. Năm Phụng vụ được cử hành thế nào?

Năm Phụng vụ bắt đầu từ Chúa nhật I Mùa Vọng và kết thúc vào lễ Chúa Kitô Vua, gồm các mùa sau:

### Mùa Vọng
Gồm 4 Chúa nhật trước lễ Giáng sinh. Đây là thời gian chuẩn bị tâm hồn mừng mầu nhiệm Chúa xuống thế làm người.

### Mùa Giáng sinh
Từ lễ Giáng sinh đến lễ Chúa Giêsu chịu phép rửa. Mừng kính mầu nhiệm Nhập thể của Con Thiên Chúa.

### Mùa Chay
Từ thứ Tư lễ Tro đến lễ Vọng Phục sinh. Đây là thời gian sám hối và chuẩn bị đón mừng mầu nhiệm Tử nạn – Phục sinh của Chúa Giêsu. Tuần cuối cùng gọi là Tuần Thánh, tưởng niệm các biến cố cuối cùng trong cuộc đời trần thế của Chúa.

### Mùa Phục sinh
Từ lễ Vọng Phục sinh đến lễ Hiện xuống. Mừng Chúa Kitô chiến thắng tội lỗi và sự chết.

### Mùa Thường niên
Khoảng 34 tuần, gồm hai giai đoạn:
- Từ sau mùa Giáng sinh đến đầu Mùa Chay.
- Từ sau lễ Hiện xuống đến lễ Chúa Kitô Vua.

Trong thời gian này, Hội Thánh giúp tín hữu sống mầu nhiệm cứu độ cách trọn vẹn hơn trong đời sống thường ngày.

Ngoài ra, suốt năm Phụng vụ, Hội Thánh còn dành nhiều ngày lễ để:
- Tôn kính Đức Maria, Mẹ Thiên Chúa và Mẹ chúng ta.
- Tôn kính thánh Giuse, các thánh Tử đạo và các thánh khác là những gương mẫu thánh thiện và là những đấng cầu bầu cho chúng ta trước tòa Chúa.

## 2. Sống Năm Phụng vụ

Như cây non lớn lên và sinh hoa kết quả tùy theo thời tiết, đức tin của người tín hữu cũng tăng trưởng nhờ sống các mùa Phụng vụ. Vì thế, chúng ta cần siêng năng tham dự các nghi lễ và sống tinh thần phụng vụ trong đời sống hằng ngày.

# III. BÀI HỌC

**Hỏi:** Năm Phụng vụ là gì?  
**Trả lời:** Năm Phụng vụ là thời gian một năm bắt đầu từ Chúa nhật I Mùa Vọng, trong đó Hội Thánh cử hành các biến cố trọng đại trong cuộc đời Chúa Giêsu, Đức Maria và các thánh.

**Hỏi:** Năm Phụng vụ có mục đích gì?  
**Trả lời:** Năm Phụng vụ giúp người tín hữu hiểu và sống các mầu nhiệm đức tin cách thiết thực và sâu xa hơn.

# IV. THÁI ĐỘ SỐNG

Như cây non lớn mạnh và trổ sinh hoa trái từng mùa, tôi sẽ cố gắng sống sốt sắng các ngày lễ trong Năm Phụng vụ để sinh nhiều hoa trái nhân đức.

# V. CẦU NGUYỆN

Lạy Chúa, Hội Thánh lập ra nhiều ngày lễ trong năm để giúp chúng con suy niệm các biến cố trong cuộc đời Chúa Giêsu, Đức Maria và các thánh. Xin cho con hiểu ý nghĩa các ngày lễ và tham dự cách sốt sắng, để đời sống đức tin của con ngày càng trưởng thành hơn.`
},
{
  id: 27,
  title: "Ơn Chúa và Bí tích",
  tag: "CHƯƠNG III",
  desc: "Ơn Chúa là sự sống và sức mạnh Chúa ban cho con người, được thông ban cách hữu hiệu qua các Bí tích.",
  content: `# 📖 I. LỜI CHÚA
“Một người lính lấy giáo đâm vào cạnh sườn Người. Tức thì, máu cùng nước chảy ra” (Ga 19,34).

---

#  II. TRÌNH BÀY

Ơn Chúa là sự sống và sức mạnh Chúa ban để ta sống hạnh phúc đời này và đời sau.  
Ơn Chúa được ban cho chúng ta qua nhiều phương thế mà hiệu nghiệm nhất là các **BÍ TÍCH**.

##  Bí tích là gì?

Bí tích là những dấu chỉ bên ngoài Chúa Giêsu đã dùng để diễn tả và thông ban ơn bên trong cho loài người.

- Dấu bên ngoài: thể chất, cử chỉ, lời đọc.
- Ơn ban bên trong: khác nhau tùy từng Bí tích.

---

##  So sánh Bí tích với đời sống tự nhiên

Thánh Tôma Aquinô giúp ta hiểu Bí tích bằng cách so sánh đời sống tự nhiên với đời sống siêu nhiên:

### a. Sinh ra
- Đời sống tự nhiên: con người được sinh bởi cha mẹ.  
- Đời sống siêu nhiên: được sinh bởi nước và Thánh Thần (Bí tích Rửa tội).

### b. Duy trì sự sống
- Phần xác cần của ăn thức uống.  
- Phần hồn cần Bánh Thánh Thể.

### c. Tăng trưởng
- Phần xác cần luyện tập thân thể.  
- Phần hồn cần Bí tích Thêm sức (Chúa Thánh Thần).

### d. Chữa trị
- Phần xác cần thuốc thang.  
- Phần hồn cần Bí tích Giải tội và khi nguy tử là Bí tích Xức dầu bệnh nhân.

### e. Hôn nhân
- Xã hội cần cưới hỏi.  
- Tôn giáo cần Bí tích Hôn phối.

### f. Trách nhiệm cộng đoàn
- Xã hội cần tuyển chọn, bầu cử.  
- Tôn giáo cần Bí tích Truyền chức thánh.

---

##  Tại sao gọi các Bí tích là Bí tích đức tin?

Vì khi lãnh nhận các Bí tích, ta phải có lòng tin.  
Nhờ Bí tích, đức tin của ta được thêm mạnh mẽ và vững chắc hơn.

---

##  Những Bí tích lãnh nhận một lần

Có ba Bí tích chỉ lãnh nhận một lần:

- Rửa tội  
- Thêm sức  
- Truyền chức thánh  

Vì ba Bí tích này in vào linh hồn một dấu thiêng liêng không thể mất.

---

#  III. BÀI HỌC

### ❓ Hỏi: Ơn Chúa là gì?
👉 Ơn Chúa là sự sống và sức mạnh Chúa ban để ta sống hạnh phúc đời này và đời sau.

### ❓ Hỏi: Bí tích là gì?
👉 Bí tích là dấu chỉ bên ngoài Chúa dùng để diễn tả và thông ban ơn bên trong cho loài người.

### ❓ Hỏi: Có mấy Bí tích?
👉 Có bảy Bí tích:

- Bí tích Rửa tội  
- Bí tích Thêm sức  
- Bí tích Giải tội  
- Bí tích Thánh Thể  
- Bí tích Xức dầu bệnh nhân  
- Bí tích Hôn phối  
- Bí tích Truyền chức thánh  

---

#  IV. THÁI ĐỘ SỐNG

Các Bí tích là phương thế hữu hiệu Chúa dùng để ban ơn cho loài người.  
Tôi siêng năng học hỏi giáo lý Bí tích để lãnh nhận sốt sắng và được nhiều ơn ích hơn.

---

#  V. CẦU NGUYỆN

Lạy Chúa, không có ơn Chúa, con chẳng làm được điều gì đáng thưởng sau này.  
Xin Chúa giúp con kiên tâm học hỏi các Bí tích để xứng đáng lãnh nhận nhiều ơn Chúa hơn.
`
},
{
  id: 28,
  title: "Bí tích Rửa Tội",
  tag: "CHƯƠNG III",
  desc: "Bí tích Rửa Tội tha tội, ban sự sống siêu nhiên và làm cho ta trở nên con Thiên Chúa và con Hội Thánh.",
  content: `# 📖 I. LỜI CHÚA
“Không ai có thể vào Nước Thiên Chúa, nếu không sinh ra bởi nước và Thần Khí” (Ga 3,5).

---

# ✨ II. TRÌNH BÀY

Trong cuộc đàm thoại với ông Nicôđêmô, Chúa Giêsu nói:
“Không ai có thể vào Nước Thiên Chúa, nếu không sinh ra bởi nước và Thần Khí” (Ga 3,5).

Trước khi về trời, Người truyền cho các tông đồ:
“Anh em hãy đi và làm cho muôn dân trở thành môn đệ, làm phép rửa cho họ nhân danh Chúa Cha, Chúa Con và Chúa Thánh Thần” (Mt 28,19).

Hai lời này cho thấy tầm quan trọng và điều kiện lãnh nhận Bí tích Rửa tội.

---

## 1️⃣ Bí tích Rửa tội là gì?

Bí tích Rửa tội là Bí tích do Chúa Giêsu thiết lập:

- Tha thứ tội nguyên tổ và các tội riêng trước khi lãnh nhận.
- Thông ban sự sống siêu nhiên.
- Làm cho ta trở nên con Chúa.
- Làm cho ta trở nên con Hội Thánh.

### 🔹 Làm con Chúa

Tội lỗi làm tắc nghẽn mạch sống siêu nhiên mà Thiên Chúa đổ vào lòng ta.  
Nhờ phép Rửa, mạch sống ấy được khai thông, sự sống Thiên Chúa lại chảy vào linh hồn ta.

Nhờ đó, ta trở thành con cái Chúa và được hưởng gia nghiệp trên trời.

### 🔹 Làm con Hội Thánh

Hội Thánh là nhiệm thể của Chúa Giêsu:
- Chúa là Đầu.
- Các tín hữu là chi thể.

Người lãnh nhận Bí tích Rửa tội được tháp nhập vào nhiệm thể ấy và nhận sự sống siêu nhiên từ Hội Thánh.

---

## 2️⃣ Liên hệ với Tử nạn và Phục sinh của Chúa Giêsu

Chúa Giêsu đã:
- Chết
- Mai táng
- Sống lại

Người lãnh nhận Bí tích Rửa tội:
- Chết đi với tội lỗi
- Mai táng với Chúa
- Sống lại trong đời sống mới

Ngày xưa, người chịu phép Rửa phải ngụp lặn trong nước như được chôn trong mồ.

Cuộc Tử nạn và Phục sinh của Chúa là:
- Nguyên nhân
- Sức mạnh
- Mẫu gương cho đời sống mới của người tín hữu.

---

## 3️⃣ Người lãnh nhận Bí tích Rửa tội thề hứa gì?

- Từ bỏ ma quỷ.
- Từ bỏ những gì thuộc về ma quỷ.
- Xa lánh tội lỗi.
- Tin theo Chúa Kitô.
- Tuân giữ lề luật của Người.

---

# 📚 III. BÀI HỌC

### ❓ Hỏi: Bí tích Rửa tội có cần thiết không?

👉 Rất cần thiết, vì Chúa phán:
“Không ai có thể vào Nước Thiên Chúa, nếu không sinh ra bởi nước và Thần Khí” (Ga 3,5).

### ❓ Hỏi: Bí tích Rửa tội ban cho ta những ơn nào?

👉 Tha tội tổ tông và tội riêng, làm cho ta trở nên con Chúa và con Hội Thánh.

### ❓ Hỏi: Người lãnh nhận Bí tích Rửa tội thề hứa những gì?

👉 Thề hứa từ bỏ ma quỷ và tin theo Chúa Kitô.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Tôi quyết từ bỏ mọi ham mê tội lỗi để xứng đáng là môn đệ Chúa Kitô.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa, Bí tích Rửa tội cho con được làm con Chúa và con Hội Thánh.  
Xin cho con chuẩn bị tâm hồn xứng đáng lãnh nhận Bí tích cao trọng này.
`
},
{
  id: 29,
  title: "Bí tích Thêm Sức",
  tag: "CHƯƠNG III",
  desc: "Bí tích Thêm Sức ban dồi dào ơn Chúa Thánh Thần, giúp người tín hữu trưởng thành trong đời sống đức tin và nhiệt thành làm việc tông đồ.",
  content: `# 📖 I. LỜI CHÚA
Các Tông Đồ ở Giêrusalem nghe biết dân miền Samari đã đón nhận lời Thiên Chúa, thì cử ông Phêrô và ông Gioan đến với họ… Bấy giờ, hai ông đặt tay trên họ và họ nhận được Thánh Thần (Cv 8,14.17).

---

# ✨ II. TRÌNH BÀY

Bí tích Rửa tội ban cho ta đời sống mới của Chúa Giêsu.  
Bí tích Thêm sức tăng cường đời sống ấy, đồng thời giúp ta gắn bó với Hội Thánh và nhiệt thành làm việc tông đồ.

---

## 1️⃣ Bí tích Thêm sức là gì?

Bí tích Thêm sức là Bí tích Chúa Giêsu đã lập để ta lãnh nhận dồi dào ơn Chúa Thánh Thần.  
Chúa Thánh Thần là Ngôi Ba Thiên Chúa, Đấng thánh hóa Hội Thánh và các linh hồn.

---

## 2️⃣ Bí tích Thêm sức ban cho ta những ơn nào?

Nhờ Bí tích Thêm sức, ta lãnh nhận:

- Thần trí khôn ngoan và thông hiểu  
- Thần trí lo liệu và sức mạnh  
- Thần trí suy biết và đạo đức  
- Ơn kính sợ Chúa  

Cùng với bảy ơn Chúa Thánh Thần, Bí tích Thêm sức còn mang lại các hiệu quả sau:

### 🔹 a. Tăng cường đời sống siêu nhiên

Sự sống mới nơi người vừa được Rửa tội còn non nớt, cần được chăm sóc để lớn mạnh.  
Chúa Thánh Thần ban ơn giúp người tín hữu tiến bước trong đời sống mới mỗi ngày.

Vì thế, Bí tích Thêm sức còn được gọi là “Bí tích trưởng thành thiêng liêng”.

---

### 🔹 b. Gắn bó với Hội Thánh và thúc giục làm việc tông đồ

Ngày lễ Ngũ tuần, Chúa Thánh Thần liên kết các Tông đồ thành một cộng đoàn hiệp nhất và ban cho các ngài lòng can đảm rao giảng Chúa Kitô Tử nạn - Phục sinh.

Ngày nay, khi lãnh nhận Bí tích Thêm sức, người tín hữu:

- Gắn bó mật thiết hơn với Hội Thánh  
- Ý thức mình là thành phần của Hội Thánh  
- Chu toàn bổn phận trong Hội Thánh và xã hội  
- Trở thành chứng nhân của Chúa Kitô  

Bí tích Thêm sức tạo nên những nhân chứng sống động trong Hội Thánh.

---

## 3️⃣ Nghĩa vụ của người lãnh nhận Bí tích Thêm sức

Hiểu giá trị cao quý của ơn Chúa Thánh Thần, người tín hữu cần:

- Thường xuyên cầu nguyện với Chúa Thánh Thần và tuân theo sự hướng dẫn của Người (x. Gl 5,16-17).  
- Sống chứng nhân, trung thành với đức tin Công giáo.  
- Liên kết với Hội Thánh trong tâm tình, ý chí và hành động.  
- Tích cực tham gia các sinh hoạt tông đồ và truyền giáo.

---

# 📚 III. BÀI HỌC

### ❓ Hỏi: Bí tích Thêm sức là gì?

👉 Là Bí tích Chúa Giêsu đã lập cho ta lãnh nhận dồi dào ơn Chúa Thánh Thần.

### ❓ Hỏi: Bí tích Thêm sức ban cho ta những ơn nào?

👉 Bí tích Thêm sức tăng cường đời sống siêu nhiên, gắn bó ta cách mật thiết hơn với Hội Thánh và thúc giục ta làm việc tông đồ truyền giáo.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Như sức khỏe phần xác cần được bồi bổ, tôi siêng năng cầu nguyện với Chúa Thánh Thần, xin Người thêm sức mạnh thiêng liêng cho tôi.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa, nhờ Bí tích Thêm sức Chúa trao cho người tín hữu trách nhiệm tông đồ truyền giáo.  
Xin cho con học biết Chúa đến đâu cũng biết chia sẻ Chúa cho người khác đến đó.
`
},
{
  id: 30,
  title: "Bí tích Thánh Thể",
  tag: "CHƯƠNG III",
  desc: "Bí tích Thánh Thể là Bí tích cao trọng nhất, trong đó Chúa Giêsu hiện diện thật dưới hình bánh rượu để nuôi sống linh hồn ta.",
  content: `# 📖 I. LỜI CHÚA
“Tôi là bánh hằng sống từ trời xuống. Ai ăn bánh này, sẽ được sống muôn đời. Và bánh tôi sẽ ban tặng, chính là thịt tôi đây, để cho thế gian được sống” (Ga 6,51).

---

# ✨ II. TRÌNH BÀY

Bí tích cần thiết nhất để được sống đời đời là Bí tích Rửa tội.  
Bí tích cao trọng nhất là Bí tích Thánh Thể.

---

## 1️⃣ Bí tích Thánh Thể là gì?

Bí tích Thánh Thể là Bí tích Chúa Giêsu đã lập để ban Mình và Máu Người hiện diện dưới hình thức bánh rượu mà nuôi linh hồn ta.

### 🔹 “Hiện diện”

Khi Linh mục đọc lời truyền phép, Bánh và Rượu trở nên Mình và Máu Chúa Giêsu cách nhiệm mầu.

Đây là mầu nhiệm tình yêu cao vời, ta không thể suy thấu, nhưng phải lấy đức tin đón nhận.  
Vì thế, sau khi truyền phép, chủ tế đọc:  
**“Đây là mầu nhiệm đức tin.”**

---

### 🔹 Nuôi sống phần hồn

Chúa Giêsu dùng chính Bánh và Rượu – lương thực thiết yếu của loài người – để đổi thành Mình và Máu Người.

Điều đó dạy ta rằng:  
Như của ăn thức uống cần cho thể xác thế nào, thì Mình và Máu Chúa Giêsu cũng là lương thực cần thiết cho đời sống tâm linh như thế.

---

## 2️⃣ Phải kính thờ Chúa Giêsu trong Bí tích Thánh Thể thế nào?

Ta phải:

- Năng đến kính viếng và tôn thờ Chúa  
- Giữ sự trang nghiêm, đứng đắn trong nhà thờ  
- Siêng năng tham dự Thánh lễ  
- Hiệp lễ cách sốt sắng  

---

# 📚 III. BÀI HỌC

### ❓ Hỏi: Bí tích Thánh Thể là gì?

👉 Là Bí tích Chúa Giêsu đã lập để biến Bánh Rượu nên Mình Máu Người làm lương thực nuôi sống ta phần hồn.

---

### ❓ Hỏi: Chúa Giêsu ngự trong Bí tích Thánh Thể thế nào?

👉 Chúa Giêsu ngự thật trong Bí tích Thánh Thể, nghĩa là trong mỗi hình Bánh, hình Rượu dù nhỏ bé cũng có toàn vẹn Chúa Giêsu.

---

### ❓ Hỏi: Ta phải kính thờ Chúa Giêsu trong Thánh Thể thế nào?

👉 Ta phải năng đến kính viếng, tôn thờ, giữ sự nghiêm trang trong nhà thờ, nhất là siêng năng tham dự Thánh lễ và hiệp lễ sốt sắng.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Thánh Thể là Bí tích trọng đại nhất và là lương thực nuôi sống linh hồn.

Hiện giờ tôi chưa được hiệp lễ, nhưng tôi cố gắng giữ thái độ cung kính mỗi khi bước vào nhà thờ và ước ao được hiệp lễ.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa Giêsu, Chúa đã phán:  
“Ai ăn thịt và uống máu tôi, thì được sống muôn đời” (Ga 6,54).

Con chưa được rước Chúa, nhưng con tin vững vàng Chúa ngự thật trong Bí tích Thánh Thể.  
Xin đừng để con bao giờ nghi ngờ điều ấy.
`
},
{
  id: 31,
  title: "Thánh lễ",
  tag: "CHƯƠNG III",
  desc: "Thánh lễ là Hy Tế tạ ơn bằng Mình và Máu Chúa Giêsu, được Hội Thánh cử hành để tưởng nhớ cuộc Tử nạn và Phục sinh của Người.",
  content: `# 📖 I. LỜI CHÚA
“Điều tôi đã lãnh nhận từ nơi Chúa, tôi xin truyền lại cho anh em: trong đêm bị nộp, Chúa Giêsu cầm lấy bánh, dâng lời chúc tụng tạ ơn, rồi bẻ ra và nói: ‘Anh em cầm lấy mà ăn, đây là Mình Thầy, hiến tế vì anh em; anh em hãy làm như Thầy vừa làm để tưởng nhớ đến Thầy’” (1 Cr 11,23-24).

---

# ✨ II. TRÌNH BÀY

Trong bữa tiệc sau hết, Chúa Giêsu đã thiết lập Hy Tế tạ ơn bằng Mình và Máu Người.  
Nhờ đó, Hy Tế Núi Sọ được kéo dài qua các thời đại, và Hội Thánh được ủy thác nhiệm vụ tưởng nhớ cái chết và sự sống lại của Người.

Ta gọi Hy Tế tạ ơn bằng Mình và Máu Chúa Giêsu là **Thánh lễ**.

Đây là Bí tích tình yêu, dấu chỉ hiệp nhất, mối dây bác ái,  
“trong đó, chúng ta rước Chúa Giêsu, sẽ được tràn đầy ân sủng và được bảo đảm cuộc sống tương lai hạnh phúc vĩnh hằng” (PV 47).

---

## 1️⃣ Thánh lễ là gì?

Thánh lễ là Hy Tế Chúa Giêsu nhờ tay Linh mục hợp cùng toàn thể dân Chúa mà dâng mình cho Đức Chúa Cha, như xưa chính Người đã dâng mình trên thánh giá.

---

## 2️⃣ Thánh lễ gồm mấy phần?

Không kể nghi thức nhập lễ và kết lễ, Thánh lễ gồm hai phần chính:

### 🔹 a. Phụng vụ Lời Chúa

Gồm:
- Lời cầu nguyện  
- Bài đọc Thánh Kinh  
- Đáp ca  
- Bài giảng  
- Lời nguyện giáo dân  

### 🔹 b. Phụng vụ Thánh Thể

Gồm:
- Chuẩn bị lễ vật  
- Kinh nguyện Thánh Thể  
- Hiệp lễ  

Hai phần liên kết chặt chẽ với nhau.  
Thánh lễ là một hoạt động duy nhất:  
Lắng nghe Lời Chúa để được hướng đến Thánh Thể.

Vì thế, Hội Thánh kêu mời người tín hữu tham dự trọn vẹn cả hai phần.

---

## 3️⃣ Ai có quyền cử hành Thánh lễ?

Chính Chúa Giêsu đã truyền cho các Tông đồ và những người có chức Linh mục được cử hành Thánh lễ:  
“Anh em hãy làm như Thầy vừa làm để tưởng nhớ đến Thầy.”

---

## 4️⃣ Phải tham dự Thánh lễ thế nào?

Vì Thánh lễ là hành động phụng vụ cao cả nhất của toàn thể dân thánh dâng lên Chúa để:

- Ngợi khen  
- Cảm tạ  
- Xin ơn tha thứ  
- Cầu khẩn mọi ơn lành hồn xác  

Cho nên:

- Phải hợp lòng hợp ý với chủ tế và cộng đoàn  
- Tham dự cách ý thức, thành kính và linh động  
- Nên tham dự cách hoàn hảo bằng việc hiệp lễ  

Việc hiệp lễ giúp ta:

- Kết hợp mật thiết với Chúa Giêsu  
- Hợp nhất với nhau  
- Xóa bỏ tội nhẹ  
- Gia tăng ơn thánh hóa  
- Thêm sức chống trả cám dỗ  
- Đảm bảo đời sống vĩnh cửu  

Thánh lễ Chúa Nhật có tầm quan trọng đặc biệt vì:

- Tính cộng đoàn  
- Mừng mầu nhiệm Phục sinh  
- Các bài đọc hướng dẫn đời sống đức tin suốt tuần  

---

## 5️⃣ Ta phải sống Thánh lễ thế nào?

Tham dự Thánh lễ là tiếp nhận nguồn sinh lực siêu nhiên.

Vì vậy cần:

- Cảm tạ Chúa vì mọi hồng ân  
- Sửa chữa nết xấu  
- Phục vụ mọi người trong yêu thương  
- Liên kết với Chúa Giêsu mà dâng mọi vui buồn, sướng khổ, sinh hoạt hằng ngày lên Chúa Cha  

---

# 📚 III. BÀI HỌC

### ❓ Hỏi: Thánh lễ là gì?

👉 Thánh lễ là Hy Tế Chúa Giêsu nhờ tay Linh mục hợp cùng toàn thể dân Chúa mà dâng mình cho Chúa Cha như xưa chính Người đã dâng mình trên thánh giá.

---

### ❓ Hỏi: Thánh lễ có mấy phần?

👉 Thánh lễ có hai phần chính: Phụng vụ Lời Chúa và Phụng vụ Thánh Thể.

---

### ❓ Hỏi: Phải tham dự Thánh lễ thế nào?

👉 Phải hợp lòng hợp ý với chủ tế và cộng đoàn để dâng lễ, tham dự cách ý thức, thành kính và linh động, nhất là dọn lòng hiệp lễ.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Mỗi khi tham dự Thánh lễ, tôi lắng nghe Lời Chúa và hiệp dâng đời sống của tôi lên Thiên Chúa.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa, Thánh lễ là nguồn mạch và chóp đỉnh của đời sống Kitô Giáo.  
Xin cho con biết yêu mến và quý trọng Thánh lễ.
`
},
{
  id: 32,
  title: "Nghi thức gia nhập Kitô Giáo",
  tag: "BÀI ĐỌC THÊM",
  desc: "Nghi thức gia nhập Kitô Giáo là hành trình phụng vụ đưa người dự tòng lãnh nhận ba Bí tích khai tâm: Rửa tội, Thêm sức và Thánh Thể.",
  content: `# 📖 NGHI THỨC GIA NHẬP KITÔ GIÁO

Nói đến nghi thức gia nhập Kitô Giáo, bạn đừng xem đó như việc gia nhập một lớp nghệ thuật, một môn học hay một tổ chức xã hội. Đây là việc thực hành một truyền thống lâu đời của Hội Thánh: một hành trình thiêng liêng, nhờ các nghi thức phụng vụ, bạn được từng bước dẫn vào Hội Thánh để sống đức tin của Dân Thiên Chúa.

Nghi thức gia nhập Kitô Giáo ban cho người dự tòng ba Bí tích khai tâm:
- Bí tích Rửa tội
- Bí tích Thêm sức
- Bí tích Thánh Thể

Theo sắc lệnh của Thánh Bộ về phụng tự đề ngày 06/01/1972, có hai hình thức nhập đạo người lớn:
- Nghi thức theo từng giai đoạn
- Nghi thức đơn giản

Phần lớn các nơi cử hành theo nghi thức đơn giản, thường diễn ra trong Thánh lễ.

---

# ✨ CÁC PHẦN CỦA NGHI THỨC ĐƠN GIẢN

## 1️⃣ Nghi thức tiếp nhận

Đón tiếp ở cửa nhà thờ – nhà thờ là hình ảnh Hội Thánh.

Việc được đón nhận ở cửa nhà thờ có nghĩa:
- Bạn được đón nhận vào Hội Thánh
- Được nhìn nhận là một phần tử của Hội Thánh
- Được sinh hoạt trong cộng đoàn dân Chúa

---

## 2️⃣ Phụng vụ Lời Chúa

Bạn được nuôi dưỡng bằng lương thực thiêng liêng:
- Các bài đọc Thánh Kinh
- Lời giảng của Linh mục
- Lời cầu xin
- Nghi thức xức dầu dự tòng

### ✨ Ý nghĩa của dầu

Dầu tượng trưng:
- Lương thực nuôi sống
- Thuốc chữa lành
- Sức mạnh và dẻo dai
- Niềm vui và hương thơm

Dầu còn dùng để:
- Thánh hiến (bàn thờ, chén lễ...)
- Trao nhiệm vụ (nghi thức truyền chức, phong vương)
- Thông ban Thần Khí

---

## 3️⃣ Nghi lễ Rửa tội

Đây là nghi lễ cốt yếu.

Nhờ Rửa tội, bạn:
- Trở nên con Thiên Chúa
- Trở nên con Hội Thánh
- Tham dự ba chức vụ của Chúa Kitô: Ngôn sứ, Tư tế, Vương giả

Trước khi lãnh nhận nước Rửa tội:
- Bạn tuyên bố từ bỏ ma quỷ
- Bạn tuyên xưng Đức tin

Sau đó, bạn lãnh nhận:

### 🤍 Áo trắng
Biểu tượng:
- Trở thành tạo vật mới
- Giữ đời sống thanh khiết

### 🕯️ Nến sáng
Biểu tượng:
- Được Chúa Kitô soi sáng
- Trở nên ánh sáng cho người khác

---

## 4️⃣ Cử hành Bí tích Thêm sức

Gồm:
- Đặt tay
- Cầu nguyện
- Xức dầu hiến thánh

### ✋ Đặt tay
- Thông ban Thần Khí
- Trao sứ mạng
- Biểu lộ sự thuộc về Thiên Chúa

### 🙏 Lời cầu nguyện
Xin Chúa Thánh Thần tuôn đổ dồi dào ơn thánh.

### ✨ Xức dầu hiến thánh
- Ghi ấn tín thiêng liêng không thể xóa nhòa
- Trao nhiệm vụ làm chứng nhân đức tin
- Thúc đẩy làm việc tông đồ truyền giáo

---

## 5️⃣ Cử hành Bí tích Thánh Thể

Bạn tham dự Thánh lễ lần đầu với tư cách người con Chúa.

Bạn được hiệp lễ:
- Hồng ân cao quý nhất
- Phần thưởng của hành trình học và sống đức tin

Niềm vui được diễn tả qua:
- Áo trắng
- Nến sáng
- Gương mặt hân hoan tiến lên hiệp lễ

Sau Thánh lễ, bạn nên:
- Đến tòa Đức Mẹ
- Cảm tạ Chúa
- Xin Mẹ giúp sống trung thành với ơn gọi mới

---

# 🌿 KẾT LUẬN

Từ đây, bạn là người Công giáo thực thụ:
- Có mọi quyền lợi
- Có mọi nghĩa vụ
- Là phần tử sống động của Hội Thánh

Chúc bạn tràn đầy niềm vui và hạnh phúc trong hành trình đức tin.
`
},
{
  id: 33,
  title: "Nghi thức gia nhập Kitô Giáo",
  tag: "BÀI ĐỌC THÊM",
  desc: "Nghi thức gia nhập Kitô Giáo là hành trình phụng vụ đưa người dự tòng lãnh nhận ba Bí tích khai tâm: Rửa tội, Thêm sức và Thánh Thể.",
  content: `# 📖 NGHI THỨC GIA NHẬP KITÔ GIÁO

Nói đến nghi thức gia nhập Kitô Giáo, bạn đừng xem đó như việc gia nhập một lớp học hay một tổ chức xã hội. Đây là việc thực hành một truyền thống lâu đời của Hội Thánh, một hành trình đức tin qua các nghi thức phụng vụ để được dẫn vào đời sống của Dân Thiên Chúa.

Nghi thức gia nhập Kitô Giáo ban cho người dự tòng **ba Bí tích khai tâm**:

- Bí tích Rửa Tội  
- Bí tích Thêm Sức  
- Bí tích Thánh Thể  

Theo sắc lệnh của Thánh Bộ Phụng Tự (06/01/1972), có hai hình thức nhập đạo người lớn:

- Nghi thức theo từng giai đoạn  
- Nghi thức đơn giản  

Phần lớn các nơi cử hành theo nghi thức đơn giản trong Thánh lễ.

---

## 1️⃣ Nghi thức tiếp nhận

Diễn ra tại cửa nhà thờ.  
Nhà thờ là hình ảnh Hội Thánh. Việc đón tiếp ở cửa nhà thờ có nghĩa là bạn được đón nhận vào Hội Thánh và trở thành một phần tử của cộng đoàn đức tin.

---

## 2️⃣ Phụng vụ Lời Chúa

Bạn được nuôi dưỡng bằng Lời Chúa qua các bài đọc Thánh Kinh và bài giảng.

Sau đó là:

- Lời cầu xin  
- Xức dầu dự tòng  

Dầu tượng trưng cho:

- Sức mạnh và niềm vui  
- Sự thánh hiến  
- Sứ mạng được trao ban  

---

## 3️⃣ Nghi lễ Rửa Tội

Đây là nghi lễ cốt yếu.

Trước khi lãnh nhận Bí tích, bạn:

- Từ bỏ ma quỷ  
- Tuyên xưng đức tin  

Sau khi chịu phép Rửa, bạn lãnh nhận:

**Áo trắng** – tượng trưng đời sống mới tinh tuyền.  
**Nến sáng** – tượng trưng ánh sáng Đức Kitô soi chiếu đời bạn.

Nhờ Bí tích Rửa tội, bạn trở nên con Thiên Chúa và con Hội Thánh.

---

## 4️⃣ Cử hành Bí tích Thêm Sức

Gồm:

- Đặt tay  
- Lời cầu nguyện  
- Xức dầu hiến thánh  

Nhờ đó bạn lãnh nhận ơn Chúa Thánh Thần và được ghi ấn tín thiêng liêng, trở nên chứng nhân đức tin.

---

## 5️⃣ Cử hành Bí tích Thánh Thể

Bạn tham dự Thánh lễ lần đầu với tư cách người con Chúa và được rước lễ.

Đây là hồng ân lớn lao, là phần thưởng của hành trình học hỏi và chuẩn bị đức tin.

Sau Thánh lễ, bạn được mời gọi cảm tạ Chúa và sống xứng đáng là người Công giáo thực thụ, tích cực tham gia đời sống cộng đoàn.

---

✨ Từ đây, bạn có đầy đủ quyền lợi và nghĩa vụ của một tín hữu Chúa Kitô.

Chúc bạn tràn đầy niềm vui và bình an.`
},
{
  id: 34,
  title: "Bí tích Xức Dầu Bệnh Nhân",
  tag: "CHƯƠNG II",
  desc: "Bí tích Xức Dầu Bệnh Nhân là bí tích Chúa Giêsu lập để nâng đỡ bệnh nhân phần hồn và phần xác, chuẩn bị họ bước vào đời sống vĩnh cửu.",
  content: `# 📖 I. LỜI CHÚA

“Ai trong anh em đau yếu ư? Người ấy hãy mời các kỳ mục của Hội Thánh đến; họ sẽ cầu nguyện cho người ấy, sau khi xức dầu nhân danh Chúa” (Gc 5,14).

---

# 📘 II. TRÌNH BÀY

Thánh Kinh viết rằng: “Mọi sự đều có lúc... có thời để sinh và có thời để chết” (Gv 3,1-2). Đau yếu, bệnh tật là dấu hiệu sức khỏe suy giảm và nhắc nhớ thân phận mong manh của con người.

Chúa Giêsu cảm thông sâu xa nỗi đau ấy nên Người thường chữa lành bệnh nhân. Người còn thiết lập Bí tích Xức Dầu Bệnh Nhân để nâng đỡ họ trong cơn thử thách và trao cho Hội Thánh tiếp tục săn sóc họ.

---

## 1️⃣ Bí tích Xức Dầu Bệnh Nhân là gì?

Là Bí tích Chúa Giêsu đã lập để ban ơn nâng đỡ bệnh nhân phần hồn và phần xác, chuẩn bị họ bước về đời sau.

### a. Nâng đỡ phần hồn

- Đem lại sự an ủi và trợ giúp thiêng liêng trong cơn thử thách  
- Củng cố đức tin, đức cậy và đức mến  
- Tẩy sạch mọi vết nhơ tội lỗi  
- Tăng sức mạnh để chiến thắng cám dỗ trong giờ phút cuối cùng  
- Giúp bệnh nhân kết hợp đau khổ với Chúa Giêsu trên thánh giá và phó thác trọn vẹn cho Thiên Chúa  

### b. Nâng đỡ phần xác

Đây là hiệu quả phụ của Bí tích. Nếu đẹp lòng Chúa, bệnh tình có thể được thuyên giảm.

Kinh nghiệm cho thấy nhiều bệnh nhân sau khi lãnh nhận Bí tích trở nên bình an, phấn khởi và có khi được khỏe lại.

---

## 2️⃣ Nên lãnh nhận Bí tích khi nào?

Các bệnh nhân có nguy cơ chết (bệnh nặng, già nua, kiệt sức, giải phẫu nguy hiểm...) thì cần lãnh nhận Bí tích Xức Dầu.

Nên lãnh nhận khi còn tỉnh táo để được hưởng nhiều hiệu quả thiêng liêng hơn.

---

# 📖 III. BÀI HỌC

**Hỏi:** Bí tích Xức Dầu Bệnh Nhân là gì?  

**Trả lời:** Là Bí tích Chúa Giêsu đã lập để ban ơn nâng đỡ bệnh nhân phần hồn phần xác và chuẩn bị bước về đời sau.

**Hỏi:** Nên lãnh nhận Bí tích Xức Dầu khi nào?  

**Trả lời:** Khi có nguy cơ chết vì bệnh nặng hoặc già yếu, và nên lãnh nhận khi còn tỉnh táo.

---

# 🌿 IV. THÁI ĐỘ SỐNG

“Sinh ký tử quy.”  
Tôi quyết chí sống xứng danh người con Chúa để khi lìa đời được về với Người.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa Giêsu, trên giường bệnh ai mà chẳng lo âu sợ sệt! Nhưng chính Chúa đã can đảm chịu chết trên thánh giá. Xin cho con biết kết hợp những đau đớn bệnh tật với sự đau khổ của Chúa, như cơ hội lập công để mai sau được về hưởng hạnh phúc với Chúa muôn đời.`
},
{
  id: 35,
  title: "Bí tích Truyền Chức Thánh",
  tag: "CHƯƠNG II",
  desc: "Bí tích Truyền Chức Thánh là bí tích Chúa Giêsu lập để thánh hiến những người được gọi phục vụ dân Chúa trong tác vụ giảng dạy, thánh hóa và lãnh đạo.",
  content: `# 📖 I. LỜI CHÚA

“Như Chúa Cha đã sai Thầy, thì Thầy cũng sai anh em” (Ga 20,21).

---

# 📘 II. TRÌNH BÀY

Hội Thánh là dân Thiên Chúa được tổ chức theo phẩm trật, gồm giáo dân và các vị lãnh đạo, mỗi người có vị trí và nhiệm vụ riêng. Các vị lãnh đạo được tuyển chọn và trao nhiệm vụ qua Bí tích Truyền Chức Thánh.

---

## 1️⃣ Bí tích Truyền Chức Thánh là gì?

Là Bí tích Chúa Giêsu đã lập để thánh hiến những người Người muốn trao cho tác vụ thánh trong dân Chúa.  

Các vị ấy gồm:

- Giám mục  
- Linh mục  
- Phó tế  

### ✨ Tác vụ thánh gồm:

- Rao giảng Lời Chúa  
- Cử hành Thánh lễ và các Bí tích  
- Tổ chức và phục vụ dân Chúa  

---

## 2️⃣ Ai có quyền ban Chức Thánh?

Chỉ các Giám mục – là Đấng kế vị các Tông đồ – mới có quyền cử hành Bí tích Truyền Chức Thánh.

---

## 3️⃣ Ai được lãnh nhận Chức Thánh?

Chỉ những người được Thiên Chúa gọi mới được lãnh nhận Chức Thánh.

Như Thánh Phaolô viết:

“Không ai tự gán cho mình vinh dự ấy, nhưng phải được Thiên Chúa gọi, như ông Aharon đã được gọi” (Hr 5,4).

Ơn gọi này:

- Phải được chính đương sự tự nguyện đáp lại  
- Và được Hội Thánh thẩm định  

---

# 📖 III. BÀI HỌC

**Hỏi:** Bí tích Truyền Chức Thánh là gì?  

**Trả lời:** Là Bí tích Chúa Giêsu đã lập để thánh hiến những vị mà Chúa muốn trao cho tác vụ thánh trong dân Chúa.

**Hỏi:** Ai được lãnh Bí tích Truyền Chức Thánh?  

**Trả lời:** Chỉ những người Thiên Chúa gọi mới được lãnh nhận chức thánh.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Các Linh mục là người thay mặt Chúa điều hành cộng đoàn.  
Tôi luôn tôn kính và vâng phục các ngài.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa, Hội Thánh là dân Thiên Chúa được tổ chức theo phẩm trật.  
Xin Chúa cho nhiều người biết quảng đại đáp lại tiếng Chúa gọi để phục vụ dân Chúa.`
},  
{
  id: 36,
  title: "Tứ Chung",
  tag: "CHƯƠNG II",
  desc: "Tứ Chung gồm bốn thực tại sau hết của đời người: Chết, Phán xét, Thiên đàng và Hỏa ngục – soi sáng số phận đời đời theo đức tin Công giáo.",
  content: `# 📖 I. LỜI CHÚA

“Khi Con Người đến trong vinh quang của Người, có tất cả các thiên sứ theo hầu, bấy giờ Người sẽ ngự lên ngai vinh hiển của Người. Các dân thiên hạ sẽ được tập hợp trước mặt Người, và Người sẽ tách biệt họ với nhau, như mục tử tách biệt chiên với dê” (Mt 25,31-32).

---

# 📘 II. TRÌNH BÀY

Ngay từ bài đầu tiên, con người đã khắc khoải về nguồn gốc và số phận đời mình: bởi đâu mà có, chết rồi đi đâu?

Đức tin Công Giáo soi sáng bốn thực tại sau hết của đời người, gọi là **Tứ Chung**:

---

## 1️⃣ Chết

### 🔹 Xét theo tự nhiên  
Chết là chấm dứt sự sống nơi sinh vật. Đó là định luật tất yếu của muôn loài.

### 🔹 Xét theo đức tin  

**a. Chết là hậu quả của tội lỗi**  
“Vì một người duy nhất mà tội lỗi đã xâm nhập trần gian và tội lỗi gây nên sự chết” (Rm 5,12).

**b. Chết là ngưỡng cửa bước vào đời sau**  
“Ai nghe lời tôi và tin vào Đấng đã sai tôi, thì có sự sống đời đời..., đã từ cõi chết bước vào cõi sống” (Ga 5,24).  
Vì thế ta thường nói một người chết là “qua đời”.

**c. Chết là tham dự vào cuộc Tử nạn của Chúa Kitô để được Phục sinh với Người**  
“Ao ước của tôi là ra đi để được ở với Đức Kitô” (Pl 1,23).

---

## 2️⃣ Phán xét

Sau khi chết, mỗi người đều bị xét xử về các việc lành dữ đã làm khi còn sống, để nhận lấy số phận đời đời: hạnh phúc hoặc đau khổ.

- Có **phán xét riêng** liền sau khi chết (x. Lc 16,19-31; Lc 23,43).
- Có **phán xét chung** vào ngày tận thế khi Chúa Giêsu Kitô đến trong vinh quang.

---

## 3️⃣ Thiên đàng

Hội Thánh tin rằng linh hồn những người chết trong ơn nghĩa Chúa và được thanh tẩy vẹn toàn sẽ được sống với Chúa Kitô trong Nước Trời.

Thánh Phaolô viết:  
“Điều mắt chẳng hề thấy, tai chẳng hề nghe, lòng người không hề nghĩ tới, đó là điều Thiên Chúa đã dọn sẵn cho những ai mến yêu Người” (1 Cr 2,9).

Thiên đàng là **trạng thái hạnh phúc trọn vẹn**, được ở với Chúa mãi mãi.

### 🔸 Luyện ngục  
Những người chết trong ơn nghĩa Chúa nhưng chưa được thanh tẩy hoàn toàn phải trải qua một cuộc thanh luyện cuối cùng trước khi vào Thiên đàng (x. Lc 3,9; 2 Mcb 12,46).

---

## 4️⃣ Hỏa ngục

Những người chết trong tình trạng tội lỗi trọng và cố tình khước từ Thiên Chúa sẽ bị xa cách Chúa đời đời.

Hình phạt nặng nề nhất của hỏa ngục là **không được hưởng nhan thánh Chúa** – sự xa cách đời đời gây nên đau khổ vô cùng (x. Lc 16,26; Mt 25,1).

Hỏa ngục là **trạng thái dứt khoát của án phạt**, hơn là một nơi chốn.

---

# 📖 III. BÀI HỌC

**Hỏi:** Xét theo đức tin Công giáo, chết là gì?  
**Trả lời:** Chết là hậu quả của tội lỗi, là ngưỡng cửa bước vào đời sau và là điều kiện để người tín hữu tham dự vào cuộc Phục sinh của Chúa Kitô.

**Hỏi:** Phán xét là gì?  
**Trả lời:** Là việc Thiên Chúa luận định tội phúc loài người đã làm khi còn sống và ấn định số phận đời đời cho họ.

**Hỏi:** Thiên đàng là gì?  
**Trả lời:** Thiên đàng là trạng thái được hạnh phúc ở với Chúa mãi mãi.

**Hỏi:** Hỏa ngục là gì?  
**Trả lời:** Hỏa ngục là trạng thái dứt khoát của án phạt mà hình phạt đau đớn nhất là phải xa Chúa đời đời.

---

# 🌿 IV. THÁI ĐỘ SỐNG

Can đảm nhìn thẳng vào sự chết để kiên trì sống thánh thiện.

---

# 🙏 V. CẦU NGUYỆN

Lạy Chúa, Chúa phán xét thật công minh.  
Xin cho con biết sống ngay thẳng với lương tâm để được Chúa đối xử khoan dung trong ngày phán xét.`
},
{
  id: 37,
  title: "Trời mới, Đất mới",
  tag: "BÀI HỌC GIÁO LÝ",
  desc: "Thiên Chúa hứa ban Trời mới Đất mới, nơi công lý và bình an ngự trị. Người tín hữu được mời gọi sống thánh thiện và tích cực xây dựng thế giới tốt đẹp hơn.",
  content: `# 🌅 BÀI 37: TRỜI MỚI, ĐẤT MỚI

---

## I. 📖 LỜI CHÚA

> “Muôn vật phải tiêu tan như thế, thì anh em phải là những người tốt dường nào, phải sống đạo đức và thánh thiện biết bao, trong khi mong đợi ngày của Thiên Chúa và làm cho ngày đó mau đến, ngày mà các tầng trời sẽ bị thiêu hủy và ngũ hành sẽ chảy tan ra trong lửa hồng. Nhưng, theo lời Thiên Chúa hứa, chúng ta mong đợi trời mới đất mới, nơi công lý ngự trị. Vì thế, anh em thân mến, trong khi mong đợi ngày đó, anh em phải cố gắng sao cho Người thấy anh em tinh tuyền, không chi đáng trách và sống bình an” (2 Pr 3,11-14).

---

## II. 📘 TRÌNH BÀY

Thế giới chúng ta đang sống luôn biến chuyển không ngừng; cảnh bãi bể nương dâu làm ngao ngán lòng người.

Nhưng những người con Chúa thì không được có tâm trạng buồn nản như thế. Ngược lại, họ phải vui sống. Thánh Kinh đã mở ra trước mắt các tín hữu một thế giới mới.

Trong thế giới mới ấy, không còn chết chóc, than vãn, kêu la, đau đớn hay đêm tối nữa (x. Kh 21,4). Người lành sẽ được sống với Thiên Chúa – nguồn suối vô tận của bình an và hiệp thông (Kh 22,5).

Không chỉ riêng loài người được hưởng hạnh phúc, mà cả vũ trụ vật chất hiện nay cũng được biến đổi (x. Rm 8,19-23). Khi thân xác con người được đổi mới, thì “ngôi nhà” của họ là vũ trụ cũng sẽ được đổi mới cho phù hợp.

Chúng ta không biết khi nào trời đất này sẽ qua đi (x. Mt 24,36; Kh 21,1), nhưng chúng ta tin chắc rằng Thiên Chúa đã chuẩn bị cho chúng ta một ngôi nhà mới, nơi công lý và hạnh phúc sẽ làm thỏa mãn mọi khát vọng chân chính của con người.

Niềm xác tín ấy thúc đẩy người tín hữu tích cực xây dựng thế giới hôm nay mỗi ngày một tốt đẹp hơn. Đó cũng chính là cách họ góp phần vào việc xây dựng “Trời mới Đất mới”.

---

## III. ❓ BÀI HỌC

**Hỏi:** Đứng trước cảnh nay còn mai mất của kiếp người, chúng ta cần có thái độ nào?  
**Trả lời:** Chúng ta cần cậy dựa vào Chúa là Đá Tảng vững chắc, đừng bám víu vào những điều chóng qua để rồi hưởng thụ hoặc thất vọng, chán chường.

**Hỏi:** Nghĩa vụ hiện tại của người tín hữu là gì?  
**Trả lời:** Trong khi chờ đợi Trời mới Đất mới, người tín hữu phải tích cực xây dựng thế giới này mỗi ngày một tốt đẹp hơn về mọi mặt: vật chất, tinh thần và tôn giáo.

---

## IV. 🌱 THÁI ĐỘ SỐNG

Trời đất này sẽ qua đi và Trời mới Đất mới sẽ xuất hiện.  
Tôi quyết tâm sống công bình, bác ái và tích cực góp phần xây dựng xã hội tốt đẹp hơn mỗi ngày.

---

## V. 🙏 CẦU NGUYỆN

Lạy Chúa, nhìn cảnh trời đất “vật đổi sao dời”, nhiều khi con cảm thấy lòng mình hoang mang.  
Nhưng vì biết Chúa là nơi nương tựa vững chắc, con xin hoàn toàn phó thác đời con cho Chúa.  
Xin giúp con luôn sống thánh thiện và hy vọng trong khi chờ đợi Trời mới Đất mới.  
Amen.
`
},
{
  id: 38,
  title: "Lời Cha chung Giáo phận",
  tag: "BÀI ĐỌC THÊM",
  desc: "Tâm tình nhắn gửi của Cha chung Giáo phận dành cho anh chị em Tân tòng: kiên vững trong đức tin, sống chứng tá và chuyên chăm cầu nguyện.",
  content: `# 💒 LỜI CHA CHUNG GIÁO PHẬN

---

## 📜 LỜI NHẮN GỬI ĐẾN ANH CHỊ EM TÂN TÒNG

Anh chị em Tân tòng thân mến,

Trong niềm vui chung vì anh chị em vừa được gia nhập Hội Thánh hôm nay, tôi muốn chia sẻ với anh chị em vài tâm tình chân thành.

Tôi rất vui mừng khi thấy anh chị em đã phấn đấu suốt thời gian qua để trở thành con Chúa và con Hội Thánh. Một mặt, anh chị em hăng say tìm hiểu Chân lý; mặt khác, anh chị em cũng đã can đảm từ bỏ những điều không phù hợp với Tin Mừng – những suy nghĩ, tình cảm và mối liên hệ từng rất gắn bó trong cuộc đời mình.  

Xin cảm tạ Thiên Chúa vì ơn Người đã thực hiện nơi anh chị em.

---

## 🌱 HƯỚNG VỀ TƯƠNG LAI

### a. Đời sống đức tin giữa đời thường

Khung cảnh vào Đạo đầy cảm xúc và an ủi đã qua. Giờ đây anh chị em trở lại đời sống thường ngày – với niềm vui và nỗi buồn, thành công và thất bại.

Đời sống đạo cũng vậy, sẽ trải qua những “mùa” khác nhau như Xuân, Hạ, Thu, Đông. Có lúc anh chị em cảm thấy rực lửa mến, hăng say làm mọi điều Chúa dạy. Có lúc lại cảm thấy nguội lạnh, chán nản, muốn buông xuôi.

Nhưng hãy nhớ: nếu trái đất chỉ có mùa Xuân thì làm sao có mùa gặt bội thu? Cái lạnh mùa Đông cũng cần thiết để hoa mai nở rộ khi Xuân về.

Vì thế, khi gặp thử thách, anh chị em hãy bình tĩnh. Hãy tìm đến các Giáo lý viên, Linh mục hay những người có kinh nghiệm để được nâng đỡ. Việc tiếp tục học hỏi Giáo lý sẽ giúp anh chị em rất nhiều trong hành trình đức tin.

---

### b. Sứ mạng lên đường

> “Anh em hãy đi và làm cho muôn dân trở thành môn đệ, làm phép rửa cho họ nhân danh Chúa Cha, Chúa Con và Chúa Thánh Thần” (Mt 28,19).

Trước đây, anh chị em nghe lời này như lời Chúa gửi đến các Tông đồ để rao giảng cho mình.  

Từ nay, anh chị em phải hiểu rằng: lời ấy cũng được gửi đến chính anh chị em – để anh chị em trở thành chứng nhân cho người khác.

Hãy “lên đường” bằng chính đời sống đổi mới của mình:
- Tuân theo hướng dẫn của Hội Thánh  
- Tham gia sinh hoạt giáo xứ  
- Thực thi bác ái với lân cận  
- Soi sáng môi trường sống bằng ngọn nến đức tin đã lãnh nhận ngày Rửa tội  

---

### c. Sống cầu nguyện

Trên hết mọi sự, anh chị em hãy chuyên chăm cầu nguyện.  

Cầu nguyện là nguồn sức sống cho đời sống đức tin và cho sứ mạng truyền giáo.  

Noi gương Đức Maria, anh chị em hãy tập suy niệm Lời Chúa mỗi ngày. Nhờ đó, anh chị em sẽ lớn lên trong ân sủng cách âm thầm nhưng vững chắc.

---

## 🙏 LỜI CHÚC LÀNH

Tôi xin phó dâng anh chị em trong tay hiền mẫu Đức Maria – Mẹ Hội Thánh – và Thánh Cả Giuse, Bổn mạng Giáo phận.

Chúc anh chị em luôn là những thành viên tích cực, sống và phục vụ Hội Thánh với niềm vui và lòng trung tín.

Amen.
`
},
{
  id: 39,
  title: "Những kinh cần thuộc",
  tag: "PHỤ LỤC",
  desc: "Tổng hợp các kinh căn bản người Kitô hữu cần thuộc lòng và thường xuyên thực hành trong đời sống đức tin.",
  content: `# 📖 NHỮNG KINH CẦN THUỘC

---

## 1️⃣ DẤU THÁNH GIÁ

Nhân danh Cha và Con và Thánh Thần. Amen.

---

## 2️⃣ KINH ĐỨC CHÚA THÁNH THẦN

Chúng con lạy ơn Đức Chúa Thánh Thần thiêng liêng sáng láng vô cùng...  
Amen.

---

## 3️⃣ KINH LẠY CHA

Lạy Cha chúng con ở trên trời, chúng con nguyện danh Cha cả sáng...  
Amen.

---

## 4️⃣ KINH KÍNH MỪNG

Kính mừng Maria đầy ơn phước...  
Amen.

---

## 5️⃣ KINH SÁNG DANH

Sáng danh Đức Chúa Cha và Đức Chúa Con và Đức Chúa Thánh Thần...  
Amen.

---

## 6️⃣ KINH TIN

Lạy Chúa, con tin thật có một Đức Chúa Trời là Đấng thưởng phạt vô cùng...  
Amen.

---

## 7️⃣ KINH CẬY

Lạy Chúa, con trông cậy vững vàng...  
Amen.

---

## 8️⃣ KINH MẾN

Lạy Chúa, con kính mến Chúa hết lòng hết sức...  
Amen.

---

## 9️⃣ KINH ĂN NĂN TỘI

Lạy Chúa, Chúa là Đấng trọn tốt trọn lành vô cùng...  
Amen.

---

## 🔟 KINH TIN KÍNH

Tôi tin kính Đức Chúa Trời là Cha phép tắc vô cùng dựng nên trời đất...  
Amen.

---

## 1️⃣1️⃣ KINH CÁO MÌNH

Tôi thú nhận cùng Thiên Chúa toàn năng và cùng anh chị em...  
Amen.

---

## 1️⃣2️⃣ KINH MƯỜI ĐIỀU RĂN

Đạo Đức Chúa Trời có Mười Điều răn:

1. Thờ phượng một Đức Chúa Trời và kính mến Người trên hết mọi sự.  
2. Chớ kêu tên Đức Chúa Trời vô cớ.  
3. Giữ ngày Chúa nhật.  
4. Thảo kính cha mẹ.  
5. Chớ giết người.  
6. Chớ làm sự dâm dục.  
7. Chớ lấy của người.  
8. Chớ làm chứng dối.  
9. Chớ muốn vợ chồng người.  
10. Chớ tham của người.

---

## 1️⃣3️⃣ KINH SÁU ĐIỀU RĂN

Hội Thánh có sáu điều răn:

1. Dâng lễ ngày Chúa nhật cùng các ngày lễ buộc.  
2. Chớ làm việc xác ngày Chúa nhật cùng các ngày lễ buộc.  
3. Xưng tội trong một năm ít là một lần.  
4. Chịu Mình Thánh Đức Chúa Giêsu trong mùa Phục sinh.  
5. Giữ chay những ngày Hội Thánh buộc.  
6. Kiêng thịt ngày thứ sáu cùng các ngày khác Hội Thánh dạy.

---

## 1️⃣4️⃣ KINH CẢI TỘI BẢY MỐI

Cải tội bảy mối có bảy đức:

- Khiêm nhường chớ kiêu ngạo.  
- Rộng rãi chớ hà tiện.  
- Giữ mình sạch sẽ chớ mê dâm dục.  
- Hay nhịn, chớ hờn giận.  
- Kiêng bớt chớ mê ăn uống.  
- Yêu người chớ ghen ghét.  
- Siêng năng việc Đức Chúa Trời chớ làm biếng.

---

## 1️⃣5️⃣ KINH TÁM MỐI PHÚC THẬT

Phúc thật tám mối:

1. Ai có lòng khó khăn...  
2. Ai hiền lành...  
3. Ai khóc lóc...  
4. Ai khao khát nhân đức trọn lành...  
5. Ai thương xót người...  
6. Ai giữ lòng sạch sẽ...  
7. Ai làm cho người hòa thuận...  
8. Ai chịu khốn nạn vì đạo ngay...

---

## 1️⃣6️⃣ KINH CÁM ƠN

Con cám ơn Đức Chúa Trời là Chúa lòng lành vô cùng...  
Amen.

---

## 1️⃣7️⃣ KINH TRÔNG CẬY

Chúng con trông cậy rất thánh Đức Mẹ Chúa Trời...  
Amen.

---

## 1️⃣8️⃣ PHÉP LẦN HẠT NGẮM TẮT

### 🌸 NĂM SỰ VUI
- Truyền tin  
- Thăm viếng  
- Giáng sinh  
- Dâng Con  
- Tìm lại Con  

### 💔 NĂM SỰ THƯƠNG
- Lo buồn đổ mồ hôi máu  
- Chịu đánh đòn  
- Đội mão gai  
- Vác Thánh giá  
- Chịu chết  

### 🌟 NĂM SỰ MỪNG
- Sống lại  
- Lên trời  
- Thánh Thần hiện xuống  
- Đức Mẹ lên trời  
- Đức Mẹ được thưởng  

### ✨ NĂM SỰ SÁNG
- Chịu Phép Rửa  
- Tiệc cưới Cana  
- Rao giảng Nước Trời  
- Biến hình  
- Lập Bí Tích Thánh Thể  

---

🙏 **Nguyện xin Chúa giúp chúng con siêng năng đọc kinh, sống đạo và thực hành đức tin mỗi ngày. Amen.**
`
},
{
  id: 40,
  title: "Nghi Thức Thánh Lễ Công Giáo",
  tag: "PHỤNG VỤ",
  desc: "Nghi Thức Thánh Lễ theo Sách Lễ Rôma 2002. Bản dịch Tiếng Việt được Tòa Thánh phê chuẩn ngày 10/05/2005. Giáo Hội Việt Nam áp dụng từ Lễ Phục Sinh 2006. Phần Kinh Nguyện Thánh Thể đã bổ sung tên thánh Giuse theo quy định của HĐGMVN ban hành ngày 13/10/2013.",
  content: `# ✝️ NGHI THỨC THÁNH LỄ CÔNG GIÁO

📖 Dựa theo Sách Lễ Rôma 2002  
📜 Bản dịch Tiếng Việt được Tòa Thánh phê chuẩn ngày 10/05/2005  
⛪ Áp dụng tại Việt Nam từ Lễ Phục Sinh 2006  
➕ Phần Kinh Nguyện Thánh Thể đã bổ sung tên thánh Giuse (HĐGMVN 13/10/2013)

---

# I. NGHI THỨC ĐẦU LỄ

## 1️⃣ Ca nhập lễ

Khi cộng đoàn đã tề tựu đông đủ, linh mục cùng đoàn giúp lễ tiến đến bàn thờ trong khi hát (hoặc đọc) ca nhập lễ.  

Tới bàn thờ:
- Cúi chào bàn thờ  
- Linh mục hôn kính bàn thờ  
- Có thể xông hương  

Sau đó về ghế chủ tọa.

### Dấu Thánh Giá

**Linh mục:** Nhân danh Cha, và Con và Thánh Thần.  
**Cộng đoàn:** Amen.

---

## 2️⃣ Lời chào

**Linh mục:**  
Nguyện xin ân sủng Đức Giêsu Kitô, Chúa chúng ta,  
tình yêu của Chúa Cha và ơn thông hiệp của Chúa Thánh Thần  
ở cùng tất cả anh chị em.

**Cộng đoàn:** Và ở cùng cha.

Hoặc:

**Linh mục:** Chúa ở cùng anh chị em.  
**Cộng đoàn:** Và ở cùng cha.

---

## 3️⃣ Nghi thức sám hối

**Linh mục:**  
Anh chị em, chúng ta hãy nhìn nhận tội lỗi chúng ta,  
để xứng đáng cử hành mầu nhiệm thánh.

### Kinh Sám Hối

**Cộng đoàn:**

Tôi thú nhận cùng Thiên Chúa toàn năng,  
và cùng anh chị em:  
tôi đã phạm tội nhiều trong tư tưởng, lời nói, việc làm  
và những điều thiếu sót.

(Đấm ngực mỗi lần đọc:)

Lỗi tại tôi, lỗi tại tôi, lỗi tại tôi mọi đàng.

Vì vậy, tôi xin Đức Bà Maria trọn đời đồng trinh,  
các Thiên Thần, các Thánh  
và anh chị em,  
khẩn cầu cho tôi trước tòa Thiên Chúa, Chúa chúng ta.

**Linh mục:**  
Xin Thiên Chúa toàn năng thương xót, tha tội  
và dẫn đưa chúng ta đến sự sống muôn đời.  
**Cộng đoàn:** Amen.

---

## 4️⃣ Kinh Thương Xót

Xin Chúa thương xót chúng con.  
Xin Chúa Kitô thương xót chúng con.  
Xin Chúa thương xót chúng con.

---

## 5️⃣ Kinh Vinh Danh  
*(Không đọc trong Mùa Vọng và Mùa Chay)*

Vinh danh Thiên Chúa trên các tầng trời,  
và bình an dưới thế cho người thiện tâm...  
Amen.

---

## 6️⃣ Lời nguyện nhập lễ

**Linh mục:** Chúng ta dâng lời cầu nguyện.

Linh mục đọc lời nguyện kết:

Chúng con cầu xin, nhờ Đức Giêsu Kitô Con Chúa,  
Người hằng sống và hiển trị cùng Chúa,  
hiệp nhất với Chúa Thánh Thần  
đến muôn thuở muôn đời.

**Cộng đoàn:** Amen.

Cộng đoàn ngồi.

---

# II. PHỤNG VỤ LỜI CHÚA

## 1️⃣ Bài đọc I  
Cuối bài đọc:

**Người đọc:** Đó là Lời Chúa.  
**Cộng đoàn:** Tạ ơn Chúa.

---

## 2️⃣ Đáp ca  
Cộng đoàn đáp theo câu đáp.

---

## 3️⃣ Bài đọc II  
(Chúa Nhật và lễ trọng)

**Đó là Lời Chúa.**  
**Tạ ơn Chúa.**

---

## 4️⃣ Alleluia  
(Hoặc câu xướng khác trong Mùa Chay)

---

## 5️⃣ Công bố Tin Mừng

**Linh mục/Phó tế:**  
Chúa ở cùng anh chị em.  
**Cộng đoàn:** Và ở cùng cha.

Tin Mừng Chúa Giêsu Kitô theo thánh...

**Cộng đoàn:** Lạy Chúa, vinh danh Chúa.

(Kết thúc:)

**Linh mục:** Đó là Lời Chúa.  
**Cộng đoàn:** Lạy Chúa Kitô, ngợi khen Chúa.

---

## 6️⃣ Giảng lễ

---

## 7️⃣ Kinh Tin Kính

Tôi tin kính một Thiên Chúa là Cha toàn năng...  
Amen.

---

## 8️⃣ Lời nguyện tín hữu

**Xướng viên:** Chúng con cầu xin Chúa.  
**Cộng đoàn:** Xin Chúa nhậm lời chúng con.

Kết:

**Linh mục:** Chúng con cầu xin nhờ Đức Kitô, Chúa chúng con.  
**Cộng đoàn:** Amen.

Cộng đoàn ngồi.

---

# III. PHỤNG VỤ THÁNH THỂ

## 1️⃣ Dâng bánh và rượu

**Linh mục:**  
Anh chị em hãy cầu nguyện  
để hy lễ của tôi cũng là của anh chị em  
được Thiên Chúa là Cha toàn năng chấp nhận.

**Cộng đoàn:**  
Xin Chúa nhận hy lễ bởi tay cha...

---

## 2️⃣ Lời nguyện tiến lễ  
**Cộng đoàn:** Amen.

---

## 3️⃣ Lời tiền tụng

**Linh mục:** Chúa ở cùng anh chị em.  
**Cộng đoàn:** Và ở cùng cha.

**Linh mục:** Hãy nâng tâm hồn lên.  
**Cộng đoàn:** Chúng con đang hướng về Chúa.

**Linh mục:** Hãy tạ ơn Chúa là Thiên Chúa chúng ta.  
**Cộng đoàn:** Thật là chính đáng.

### Thánh! Thánh! Thánh!

Thánh! Thánh! Thánh!  
Chúa là Thiên Chúa các đạo binh...  

---

## 4️⃣ Kinh Tạ Ơn II

Linh mục truyền phép:

**"Tất cả các con hãy nhận lấy mà ăn:  
Vì này là Mình Thầy..."**

**"Tất cả các con hãy nhận lấy mà uống:  
Vì này là chén Máu Thầy..."**

---

## 5️⃣ Tung hô

**Chủ tế:** Đây là mầu nhiệm đức tin.  

**Cộng đoàn:**  
Lạy Chúa, chúng con loan truyền Chúa chịu chết  
và tuyên xưng Chúa sống lại  
cho tới khi Chúa đến.

---

## Vinh tụng ca

Chính nhờ Người, với Người và trong Người...  

**Cộng đoàn:** Amen.

---

# IV. NGHI THỨC HIỆP LỄ

## 1️⃣ Kinh Lạy Cha

Lạy Cha chúng con ở trên trời...  

---

## 2️⃣ Nghi thức chúc bình an

**Linh mục:**  
Lạy Chúa Giêsu Kitô, Chúa đã nói với các Tông Đồ rằng...

Xin ban bình an cho nhau.

---

## 3️⃣ Bẻ bánh

Lạy Chiên Thiên Chúa,  
Đấng xóa tội trần gian, xin thương xót chúng con...

---

## 4️⃣ Hiệp lễ

**Linh mục:**  
Đây Chiên Thiên Chúa,  
đây Đấng xóa tội trần gian.  
Phúc cho ai được mời đến dự tiệc Chiên Thiên Chúa.

**Cộng đoàn:**  
Lạy Chúa, con chẳng đáng Chúa ngự vào nhà con,  
nhưng xin Chúa phán một lời,  
thì linh hồn con sẽ lành mạnh.

---

## 5️⃣ Lời nguyện hiệp lễ  
**Cộng đoàn:** Amen.

---

# V. NGHI THỨC KẾT LỄ

## 1️⃣ Lời chào và phép lành

**Linh mục:** Chúa ở cùng anh chị em.  
**Cộng đoàn:** Và ở cùng cha.

**Linh mục:**  
Xin Thiên Chúa toàn năng là Cha,  
và Con ✝️ và Thánh Thần  
ban phúc lành cho anh chị em.

**Cộng đoàn:** Amen.

---

## 2️⃣ Sai đi

**Phó tế/Linh mục:** Lễ xong, chúc anh chị em đi bình an.  
**Cộng đoàn:** Tạ ơn Chúa.

---

🙏 Xin cho mỗi Thánh Lễ trở nên nguồn mạch ân sủng và sức sống cho đời sống Kitô hữu chúng ta.
`
}
];

export default lessons